/* GENERATED by maths-calculators/build.py, edit calcs.js not this file. */
MC_CONFIG["exam-marks-needed-calculator"] = { name: "Exam Marks Needed Calculator", fields: [{"id": "got", "label": "Marks scored so far", "type": "number", "def": "86", "min": 0}, {"id": "gotMax", "label": "Marks available so far", "type": "number", "def": "160", "gt": 0}, {"id": "remainMax", "label": "Marks still to play for", "type": "number", "def": "80", "gt": 0}, {"id": "targetPct", "label": "Target overall percentage", "suffix": "%", "type": "number", "def": "65", "gt": 0, "max": 100}], example: {"got": 86, "gotMax": 160, "remainMax": 80, "targetPct": 65}, run: (function (v, H) {
      if (v.got > v.gotMax) throw new Error('You cannot have scored more than the marks available so far.');
      var steps = [];
      var totalMax = v.gotMax + v.remainMax;
      steps.push('Total marks in the whole exam: ' + H.fmt(v.gotMax) + ' + ' + H.fmt(v.remainMax) + ' = ' + H.fmt(totalMax));
      var needTotal = v.targetPct / 100 * totalMax;
      steps.push('Marks needed for ' + H.fmt(v.targetPct) + '% overall: ' + H.fmt(v.targetPct / 100) + ' × ' + H.fmt(totalMax) + ' = ' + H.fmt(needTotal));
      var needRemain = needTotal - v.got;
      if (needRemain <= 0) {
        steps.push('You already have ' + H.fmt(v.got) + ', which is more than ' + H.fmt(needTotal));
        steps.push('So the target is already banked, more marks needed: 0');
        return { answer: 'Target already secured, 0 more marks needed', steps: steps, note: 'Anything you score now takes you past the target.' };
      }
      steps.push('You already have ' + H.fmt(v.got) + ', so you still need: ' + H.fmt(needTotal) + ' − ' + H.fmt(v.got) + ' = ' + H.fmt(needRemain));
      var rawPct = needRemain / v.remainMax * 100;
      if (rawPct > 100) {
        steps.push('The remaining papers only hold ' + H.fmt(v.remainMax) + ' marks: ' + H.fmt(needRemain) + ' ÷ ' + H.fmt(v.remainMax) + ' = ' + H.fmt(rawPct) + '%');
        return {
          answer: 'Not possible, that would need ' + H.fmt(rawPct) + '% of the remaining marks',
          steps: steps,
          note: 'Pick a lower target, and remember a strong finish still lifts the overall score.'
        };
      }
      var need = Math.ceil(needRemain);
      if (need !== needRemain) steps.push('Marks come in wholes, so round up: ' + H.fmt(needRemain) + ' becomes ' + H.fmt(need));
      var pct = need / v.remainMax * 100;
      steps.push('As a share of what is left: ' + H.fmt(need) + ' ÷ ' + H.fmt(v.remainMax) + ' = ' + H.fmt(pct) + '%');
      return {
        answer: 'At least ' + H.fmt(need) + ' of the remaining ' + H.fmt(v.remainMax) + ' marks (' + H.fmt(pct) + '%)',
        steps: steps,
        note: 'Work in raw marks, never by averaging paper percentages, papers with different totals do not average evenly.'
      };
    }), preview: (function (v, H) { return v.got + ' of ' + v.gotMax + ' so far, ' + v.remainMax + ' marks left, target ' + v.targetPct + '%'; }) };
MC_CONFIG["revision-planner"] = { name: "Revision Planner", fields: [{"id": "weeks", "label": "Weeks until the exam", "type": "number", "def": "6", "gt": 0, "max": 52}, {"id": "mins", "label": "Minutes of revision a day", "type": "number", "def": "45", "gt": 0, "max": 600}, {"id": "days", "label": "Revision days a week", "type": "number", "def": "5", "gt": 0, "max": 7, "int": true}, {"id": "topics", "label": "Topics to cover", "type": "number", "def": "12", "gt": 0, "max": 200, "int": true}], example: {"weeks": 6, "mins": 45, "days": 5, "topics": 12}, run: (function (v, H) {
      var steps = [];
      var sessions = v.weeks * v.days;
      steps.push('Revision days: ' + H.fmt(v.weeks) + ' weeks × ' + H.fmt(v.days) + ' days = ' + H.fmt(sessions) + ' days');
      var totalMins = sessions * v.mins;
      var hours = totalMins / 60;
      steps.push('Total time: ' + H.fmt(sessions) + ' × ' + H.fmt(v.mins) + ' minutes = ' + H.fmt(totalMins) + ' minutes, which is ' + H.fmt(hours) + ' hours');
      var per = totalMins / v.topics;
      steps.push('Split across ' + H.fmt(v.topics) + ' topics: ' + H.fmt(totalMins) + ' ÷ ' + H.fmt(v.topics) + ' = ' + H.fmt(per) + ' minutes per topic');
      function chip(hue, big, small) { return '<span class="mc-chip mc-chip-' + hue + '">' + big + '<small>' + small + '</small></span>'; }
      function link(t) { return '<span class="mc-link">' + t + ' →</span>'; }
      var visual = '<div class="mc-chain">'
        + chip(1, H.fmt(v.weeks), H.plural(v.weeks, 'week', 'weeks'))
        + link('× ' + H.fmt(v.days) + ' days')
        + chip(2, H.fmt(sessions), 'revision days')
        + link('× ' + H.fmt(v.mins) + ' min')
        + chip(3, H.fmt(hours) + ' h', 'total revision')
        + link('÷ ' + H.fmt(v.topics) + ' topics')
        + chip(4, H.fmt(per) + ' min', 'per topic')
        + '</div>';
      var res = {
        answer: H.fmt(hours) + ' hours of revision, ' + H.fmt(per) + ' minutes per topic',
        steps: steps,
        visual: visual
      };
      if (per < 20) res.note = 'Under 20 minutes a topic is thin, trim the topic list to the ones that carry marks, or add a few minutes a day.';
      else res.note = 'Little and often beats cramming: this many short sessions builds far more recall than the same hours in one weekend.';
      return res;
    }), preview: (function (v, H) { return v.weeks + ' weeks × ' + v.days + ' days × ' + v.mins + ' minutes, across ' + v.topics + ' topics'; }) };
MC_CONFIG["percentage-increase-decrease-calculator"] = { name: "Percentage Increase and Decrease Calculator", fields: [{"id": "amount", "label": "Starting amount", "type": "number", "def": "240"}, {"id": "pct", "label": "Percentage change", "suffix": "%", "type": "number", "def": "15", "gt": 0}, {"id": "dir", "label": "Direction", "type": "select", "def": "increase", "options": [["increase", "Increase it"], ["decrease", "Decrease it"]]}], example: {"amount": 240, "pct": 15, "dir": "increase"}, run: (function (v, H) {
      if (v.dir === 'decrease' && v.pct > 100) throw new Error('You cannot decrease by more than 100%, there would be less than nothing left.');
      var mult = v.dir === 'increase' ? 1 + v.pct / 100 : 1 - v.pct / 100;
      var base = v.dir === 'increase' ? '100% + ' + H.fmt(v.pct) + '% = ' + H.fmt(100 + v.pct) + '%' : '100% − ' + H.fmt(v.pct) + '% = ' + H.fmt(100 - v.pct) + '%';
      var ans = v.amount * mult;
      return {
        answer: H.fmt(ans),
        steps: [
          'Find the multiplier: ' + base + ', which is ' + H.fmt(mult) + ' as a decimal',
          'Multiply once: ' + H.fmt(v.amount) + ' × ' + H.fmt(mult) + ' = ' + H.fmt(ans)
        ],
        note: 'Quick check: 10% of ' + H.fmt(v.amount) + ' is ' + H.fmt(v.amount / 10) + ', so the change of ' + H.fmt(Math.abs(ans - v.amount)) + ' should look sensible next to that.'
      };
    }), preview: (function (v, H) { return (v.dir === 'increase' ? 'Increase ' : 'Decrease ') + v.amount + ' by ' + v.pct + '%'; }) };
MC_CONFIG["vat-calculator"] = { name: "VAT Calculator", fields: [{"id": "amount", "label": "Price", "prefix": "\u00a3", "type": "number", "def": "150", "gt": 0}, {"id": "rate", "label": "VAT rate", "suffix": "%", "type": "number", "def": "20", "gt": 0, "max": 100}, {"id": "mode", "label": "What to do", "type": "select", "def": "add", "options": [["add", "Add VAT (price is before VAT)"], ["remove", "Remove VAT (price includes it)"]]}], example: {"amount": 150, "rate": 20, "mode": "add"}, run: (function (v, H) {
      var mult = 1 + v.rate / 100;
      if (v.mode === 'add') {
        var vat = v.amount * v.rate / 100;
        var gross = v.amount + vat;
        return {
          answer: 'VAT ' + H.money(vat) + '. Total with VAT ' + H.money(gross),
          steps: [
            'VAT is ' + H.fmt(v.rate) + '% of the price: ' + H.fmt(v.rate / 100) + ' × ' + H.fmt(v.amount) + ' = ' + H.money(vat),
            'Add it on: ' + H.money(v.amount) + ' + ' + H.money(vat) + ' = ' + H.money(gross)
          ],
          note: 'One-step version: multiply by ' + H.fmt(mult) + '.'
        };
      }
      var net = v.amount / mult;
      var vat2 = v.amount - net;
      return {
        answer: 'Price before VAT ' + H.money(net) + '. VAT ' + H.money(vat2),
        steps: [
          'A price with VAT is ' + H.fmt(100 + v.rate) + '% of the original, so divide by the multiplier: ' + H.fmt(v.amount) + ' ÷ ' + H.fmt(mult) + ' = ' + H.money(net),
          'The VAT part is the difference: ' + H.money(v.amount) + ' − ' + H.money(net) + ' = ' + H.money(vat2)
        ],
        note: 'Never take ' + H.fmt(v.rate) + '% off the gross price. That subtracts too much, because the VAT was ' + H.fmt(v.rate) + '% of the SMALLER pre-VAT price.'
      };
    }), preview: (function (v, H) { return v.mode === 'add' ? 'Add ' + v.rate + '% VAT to £' + v.amount : 'Remove ' + v.rate + '% VAT from £' + v.amount; }) };
MC_CONFIG["growth-and-decay-calculator"] = { name: "Growth and Decay Calculator", fields: [{"id": "start", "label": "Starting value", "type": "number", "def": "2000", "gt": 0}, {"id": "rate", "label": "Change each period", "suffix": "%", "type": "number", "def": "5", "gt": 0}, {"id": "periods", "label": "Number of periods (years)", "type": "number", "def": "3", "gt": 0, "int": true, "max": 50}, {"id": "dir", "label": "Direction", "type": "select", "def": "grow", "options": [["grow", "Growth (goes up)"], ["decay", "Decay (goes down)"]]}], example: {"start": 2000, "rate": 5, "periods": 3, "dir": "grow"}, run: (function (v, H) {
      if (v.dir === 'decay' && v.rate >= 100) throw new Error('Decay of 100% or more leaves nothing after one period. Use a rate under 100.');
      var mult = v.dir === 'grow' ? 1 + v.rate / 100 : 1 - v.rate / 100;
      var result = v.start * Math.pow(mult, v.periods);
      var steps = [
        'Find the multiplier: ' + (v.dir === 'grow' ? '100% + ' : '100% − ') + H.fmt(v.rate) + '% = ' + H.fmt(mult),
        'Apply it ' + H.fmt(v.periods) + ' ' + H.plural(v.periods, 'time', 'times') + ': ' + H.fmt(v.start) + ' × ' + H.fmt(mult) + H.sup(v.periods) + ' = ' + H.fmt(result)
      ];
      if (v.periods <= 5) {
        var chain = [H.fmt(v.start)], val = v.start;
        for (var i = 0; i < v.periods; i++) { val *= mult; chain.push(H.fmt(val)); }
        steps.splice(1, 0, 'Watch it move period by period: ' + chain.join(' → '));
      }
      return {
        answer: H.fmt(result), steps: steps,
        note: 'Each period the change is worked out on the NEW value, not the starting one. That is what makes it compound.'
      };
    }), preview: (function (v, H) { return v.start + ' ' + (v.dir === 'grow' ? 'growing' : 'shrinking') + ' by ' + v.rate + '% for ' + v.periods + ' periods'; }) };
MC_CONFIG["best-buy-calculator"] = { name: "Best Buy Calculator", fields: [{"id": "p1", "group": "A", "groupLabel": "Deal A", "label": "Deal A: price", "prefix": "\u00a3", "type": "number", "def": "2.40", "gt": 0}, {"id": "q1", "group": "A", "label": "Deal A: amount (g, ml or items)", "type": "number", "def": "300", "gt": 0}, {"id": "p2", "group": "B", "groupLabel": "Deal B", "label": "Deal B: price", "prefix": "\u00a3", "type": "number", "def": "1.80", "gt": 0}, {"id": "q2", "group": "B", "label": "Deal B: amount (same units)", "type": "number", "def": "200", "gt": 0}], example: {"p1": 2.4, "q1": 300, "p2": 1.8, "q2": 200}, run: (function (v, H) {
      var per = Math.max(v.q1, v.q2) >= 100 ? 100 : 1;
      var u1 = v.p1 / v.q1 * per;
      var u2 = v.p2 / v.q2 * per;
      var unitWord = per === 100 ? 'per 100' : 'each';
      var steps = [
        'Put both deals on the same scale, price ' + unitWord + ': A is ' + H.money(v.p1) + ' ÷ ' + H.fmt(v.q1) + (per === 100 ? ' × 100' : '') + ' = ' + H.money(u1),
        'Same for B: ' + H.money(v.p2) + ' ÷ ' + H.fmt(v.q2) + (per === 100 ? ' × 100' : '') + ' = ' + H.money(u2)
      ];
      if (Math.abs(u1 - u2) < 1e-9) {
        steps.push('Both cost ' + H.money(u1) + ' ' + unitWord + ', so the deals are identical value');
        return { answer: 'Identical value: both ' + H.money(u1) + ' ' + unitWord, steps: steps };
      }
      var aWins = u1 < u2;
      var winner = aWins ? 'A' : 'B';
      var wp = aWins ? u1 : u2, lp = aWins ? u2 : u1;
      steps.push('Compare: ' + H.money(wp) + ' beats ' + H.money(lp) + ' ' + unitWord + ', so Deal ' + winner + ' is the better buy');
      return {
        answer: 'Deal ' + winner + ' is the better buy: ' + H.money(wp) + ' vs ' + H.money(lp) + ' ' + unitWord,
        steps: steps,
        note: 'In an exam, always show both unit prices. The comparison line is where the mark lives.'
      };
    }), preview: (function (v, H) { return 'A: £' + v.p1 + ' for ' + v.q1 + '   vs   B: £' + v.p2 + ' for ' + v.q2; }) };
MC_CONFIG["exchange-rate-calculator"] = { name: "Exchange Rate Calculator", fields: [{"id": "rate", "label": "Exchange rate: \u00a31 buys", "type": "number", "def": "1.15", "gt": 0}, {"id": "amount", "label": "Amount to convert", "type": "number", "def": "200", "gt": 0}, {"id": "mode", "label": "Direction", "type": "select", "def": "out", "options": [["out", "Pounds into the other currency"], ["back", "Other currency into pounds"]]}], example: {"rate": 1.15, "amount": 200, "mode": "out"}, run: (function (v, H) {
      if (v.mode === 'out') {
        var got = v.amount * v.rate;
        return {
          answer: H.fmt(got) + ' in the other currency',
          steps: [
            'Every £1 becomes ' + H.fmt(v.rate) + ', so multiply: ' + H.fmt(v.amount) + ' × ' + H.fmt(v.rate) + ' = ' + H.fmt(got)
          ],
          note: 'Sense check: the rate is above 1, so you should end up with a bigger number than you started with.'
        };
      }
      var back = v.amount / v.rate;
      return {
        answer: H.money(back),
        steps: [
          'Going back to pounds undoes the multiply, so divide: ' + H.fmt(v.amount) + ' ÷ ' + H.fmt(v.rate) + ' = ' + H.money(back)
        ],
        note: 'Multiplying out, dividing back only works this way round when the rate is written as £1 = something.'
      };
    }), preview: (function (v, H) { return v.mode === 'out' ? '£' + v.amount + ' at a rate of £1 = ' + v.rate : v.amount + ' (other currency) at £1 = ' + v.rate; }) };
MC_CONFIG["nth-term-calculator"] = { name: "Nth Term Calculator", fields: [{"id": "terms", "label": "The sequence", "type": "text", "def": "5, 8, 11, 14", "hint": "At least 3 terms for linear, 4 for quadratic. Commas between them."}], example: {"terms": "5, 8, 11, 14"}, run: (function (v, H) {
      var raw = String(v.terms).trim().split(/[\s,]+/).filter(function (t) { return t !== ''; });
      var t = [];
      for (var i = 0; i < raw.length; i++) {
        var n = Number(raw[i]);
        if (!isFinite(n)) throw new Error('"' + raw[i] + '" is not a number. Use digits separated by commas.');
        t.push(n);
      }
      if (t.length < 3) throw new Error('Enter at least three terms.');
      if (t.length > 12) throw new Error('Twelve terms is plenty. Trim the list.');
      function diffs(arr) {
        var d = [];
        for (var j = 1; j < arr.length; j++) d.push(arr[j] - arr[j - 1]);
        return d;
      }
      function allSame(arr) {
        for (var k = 1; k < arr.length; k++) { if (Math.abs(arr[k] - arr[0]) > 1e-9) return false; }
        return true;
      }
      function lin(coef, cons) {
        var nPart = coef === 1 ? 'n' : coef === -1 ? '−n'
          : (coef < 0 ? '−' + H.fmt(-coef) : H.fmt(coef)) + 'n';
        if (coef === 0) nPart = '';
        var cPart = cons === 0 ? '' : (cons > 0 ? (nPart ? ' + ' : '') + H.fmt(cons) : (nPart ? ' − ' : '−') + H.fmt(-cons));
        var out = nPart + cPart;
        return out === '' ? '0' : out;
      }
      var d1 = diffs(t);
      var steps = [];
      if (allSame(d1)) {
        var d = d1[0], c = t[0] - d;
        if (d === 0) throw new Error('Every term is the same, so the nth term is just ' + H.fmt(t[0]) + '. No rule needed.');
        var rule = lin(d, c);
        steps.push('Find the differences: ' + d1.map(function (x) { return (x >= 0 ? '+' : '') + H.fmt(x); }).join(', ') + '. The same each time, so the sequence is linear and built on ' + lin(d, 0));
        steps.push('Line ' + lin(d, 0) + ' up against the sequence: at n = 1 it gives ' + H.fmt(d) + ', but the first term is ' + H.fmt(t[0]) + ', so adjust by ' + (c >= 0 ? '+ ' + H.fmt(c) : '− ' + H.fmt(-c)));
        steps.push('The nth term is ' + rule);
        var last = t.length;
        steps.push('Check with n = ' + last + ': ' + H.fmt(d) + ' × ' + last + (c >= 0 ? ' + ' + H.fmt(c) : ' − ' + H.fmt(-c)) + ' = ' + H.fmt(d * last + c) + ', which matches the sequence');
        return {
          answer: rule, steps: steps,
          note: 'The next two terms would be ' + H.fmt(t[t.length - 1] + d) + ' and ' + H.fmt(t[t.length - 1] + 2 * d) + '.'
        };
      }
      var d2 = diffs(d1);
      if (!allSame(d2)) throw new Error('Neither the first nor the second differences settle down, so this is not a linear or quadratic sequence (or there is a typo in the list).');
      if (t.length < 4) throw new Error('For a quadratic sequence give at least four terms, so the pattern is certain.');
      var a = d2[0] / 2;
      steps.push('First differences: ' + d1.map(H.fmt).join(', ') + '. They change, so look at the second differences: ' + d2.map(H.fmt).join(', ') + ', constant, so the sequence is quadratic');
      steps.push('The n² number is half the second difference: ' + H.fmt(d2[0]) + ' ÷ 2 = ' + H.fmt(a) + ', so start with ' + (a === 1 ? '' : H.fmt(a)) + 'n²');
      var resid = [];
      for (var m = 0; m < t.length; m++) resid.push(t[m] - a * (m + 1) * (m + 1));
      steps.push('Subtract ' + (a === 1 ? '' : H.fmt(a)) + 'n² from each term: what is left is ' + resid.map(H.fmt).join(', '));
      var rd = diffs(resid);
      var b = rd.length ? rd[0] : 0;
      var c2 = resid[0] - b;
      var aPart = (a === 1 ? '' : a === -1 ? '−' : H.fmt(a)) + 'n²';
      var rule2 = aPart;
      if (b !== 0) rule2 += (b > 0 ? ' + ' : ' − ') + (Math.abs(b) === 1 ? '' : H.fmt(Math.abs(b))) + 'n';
      if (c2 !== 0) rule2 += (c2 > 0 ? ' + ' : ' − ') + H.fmt(Math.abs(c2));
      var linPart = lin(b, c2);
      steps.push('The leftover is its own linear sequence with nth term ' + linPart + ', so put the pieces together: ' + rule2);
      var lastN = t.length;
      var checkVal = a * lastN * lastN + b * lastN + c2;
      steps.push('Check with n = ' + lastN + ': ' + rule2 + ' gives ' + H.fmt(checkVal) + ', which matches the sequence');
      return { answer: rule2, steps: steps };
    }), preview: (function (v, H) { return 'Sequence: ' + v.terms + ', ...'; }) };
MC_CONFIG["solving-equations-calculator"] = { name: "Solving Equations Calculator", fields: [{"id": "a", "label": "Left side: number with x", "type": "number", "def": "3"}, {"id": "b", "label": "Left side: number on its own", "type": "number", "def": "5"}, {"id": "c", "label": "Right side: number with x", "type": "number", "def": "1"}, {"id": "d", "label": "Right side: number on its own", "type": "number", "def": "11"}], example: {"a": 3, "b": 5, "c": 1, "d": 11}, run: (function (v, H) {
      function side(k, m) {
        var xs = k === 0 ? '' : (k === 1 ? 'x' : k === -1 ? '−x' : H.fmt(k) + 'x');
        if (m === 0 && xs !== '') return xs;
        if (xs === '') return H.fmt(m);
        return xs + (m < 0 ? ' − ' + H.fmt(-m) : ' + ' + H.fmt(m));
      }
      var steps = ['Start with the equation: ' + side(v.a, v.b) + ' = ' + side(v.c, v.d)];
      if (v.a === v.c) {
        if (v.b === v.d) {
          steps.push('Both sides are identical, so every value of x works');
          return { answer: 'Every value of x works (an identity)', steps: steps };
        }
        steps.push('Take ' + H.fmt(v.c) + 'x from both sides and the x terms vanish, leaving ' + H.fmt(v.b) + ' = ' + H.fmt(v.d) + ', which is false');
        return { answer: 'No solution', steps: steps };
      }
      var ax = v.a - v.c;
      if (v.c !== 0) {
        steps.push((v.c > 0 ? 'Take ' + side(v.c, 0) + ' from both sides: ' : 'Add ' + side(-v.c, 0) + ' to both sides: ') + side(ax, v.b) + ' = ' + H.fmt(v.d));
      }
      var rhs = v.d - v.b;
      if (v.b !== 0) {
        steps.push((v.b > 0 ? 'Take ' + H.fmt(v.b) + ' from both sides: ' : 'Add ' + H.fmt(-v.b) + ' to both sides: ') + side(ax, 0) + ' = ' + H.fmt(rhs));
      }
      var x = rhs / ax;
      steps.push('Divide both sides by ' + H.fmt(ax) + ': x = ' + H.fmt(rhs) + ' ÷ ' + H.fmt(ax) + ' = ' + H.fmt(x));
      return {
        answer: 'x = ' + H.fmt(x), steps: steps,
        note: 'Check it: the left side gives ' + H.fmt(v.a * x + v.b) + ' and the right side gives ' + H.fmt(v.c * x + v.d) + '. They match.'
      };
    }), preview: (function (v, H) {
      function side(k, m) {
        var kk = k === '?' ? '?' : Number(k);
        var mm = m === '?' ? '?' : Number(m);
        var xs = kk === 0 ? '' : (kk === 1 ? 'x' : kk === -1 ? '−x' : kk + 'x');
        if (mm === 0 && xs !== '') return xs;
        if (xs === '') return String(mm);
        return xs + (typeof mm === 'number' && mm < 0 ? ' − ' + Math.abs(mm) : ' + ' + mm);
      }
      return side(v.a, v.b) + ' = ' + side(v.c, v.d);
    }) };
MC_CONFIG["inequalities-calculator"] = { name: "Inequalities Calculator", fields: [{"id": "a", "label": "Number with x", "type": "number", "def": "3"}, {"id": "b", "label": "Number on its own (left side)", "type": "number", "def": "5"}, {"id": "sym", "label": "Inequality sign", "type": "select", "def": "lt", "options": [["lt", "< (less than)"], ["le", "\u2264 (less than or equal)"], ["gt", "> (greater than)"], ["ge", "\u2265 (greater than or equal)"]]}, {"id": "c", "label": "Number on the right side", "type": "number", "def": "14"}], example: {"a": 3, "b": 5, "sym": "lt", "c": 14}, run: (function (v, H) {
      if (v.a === 0) throw new Error('The x number cannot be 0, there would be no x to solve for.');
      var S = { lt: '<', le: '≤', gt: '>', ge: '≥' };
      var FLIP = { lt: 'gt', le: 'ge', gt: 'lt', ge: 'le' };
      var sym = v.sym;
      var xs = v.a === 1 ? 'x' : v.a === -1 ? '−x' : H.fmt(v.a) + 'x';
      var steps = [];
      var rhs = v.c - v.b;
      if (v.b !== 0) {
        steps.push((v.b > 0 ? 'Take ' + H.fmt(v.b) + ' from both sides: ' : 'Add ' + H.fmt(-v.b) + ' to both sides: ') + xs + ' ' + S[sym] + ' ' + H.fmt(rhs));
      }
      var x = rhs / v.a;
      if (v.a < 0) {
        sym = FLIP[sym];
        steps.push('Divide both sides by ' + H.fmt(v.a) + ', and because that is NEGATIVE, flip the sign: x ' + S[sym] + ' ' + H.fmt(x));
      } else if (v.a !== 1) {
        steps.push('Divide both sides by ' + H.fmt(v.a) + ': x ' + S[sym] + ' ' + H.fmt(x));
      } else if (v.b === 0) {
        steps.push('Nothing to move: x ' + S[sym] + ' ' + H.fmt(x));
      }
      var ans = 'x ' + S[sym] + ' ' + H.fmt(x);
      var note;
      if (sym === 'lt' || sym === 'le') {
        var top = sym === 'lt' ? Math.ceil(x) - 1 : Math.floor(x);
        if (sym === 'lt' && Number.isInteger(x)) top = x - 1;
        note = 'The biggest integer that satisfies it is ' + H.fmt(top) + '.';
      } else {
        var bot = sym === 'gt' ? Math.floor(x) + 1 : Math.ceil(x);
        if (sym === 'gt' && Number.isInteger(x)) bot = x + 1;
        note = 'The smallest integer that satisfies it is ' + H.fmt(bot) + '.';
      }
      return { answer: ans, steps: steps, note: note };
    }), preview: (function (v, H) {
      var S = { lt: '<', le: '≤', gt: '>', ge: '≥' };
      var xs = v.a === '?' ? '?x' : (Number(v.a) === 1 ? 'x' : Number(v.a) === -1 ? '−x' : v.a + 'x');
      var bb = v.b === '?' ? ' + ?' : (Number(v.b) === 0 ? '' : Number(v.b) < 0 ? ' − ' + Math.abs(v.b) : ' + ' + v.b);
      return xs + bb + ' ' + S[v.sym] + ' ' + v.c;
    }) };
MC_CONFIG["expanding-brackets-calculator"] = { name: "Expanding Brackets Calculator", fields: [{"id": "mode", "label": "What to expand", "type": "select", "def": "double", "options": [["single", "Single bracket: k(ax + b)"], ["double", "Double brackets"]]}, {"id": "k", "label": "k, the number outside", "type": "number", "def": "3", "showIf": {"mode": ["single"]}}, {"id": "sa", "label": "Inside: number with x", "type": "number", "def": "2", "showIf": {"mode": ["single"]}}, {"id": "sb", "label": "Inside: number on its own", "type": "number", "def": "-5", "showIf": {"mode": ["single"]}}, {"id": "dax", "group": "A", "groupLabel": "First bracket", "label": "1st bracket: number with x", "type": "number", "def": "1", "showIf": {"mode": ["double"]}}, {"id": "dac", "group": "A", "label": "1st bracket: number on its own", "type": "number", "def": "2", "showIf": {"mode": ["double"]}}, {"id": "dbx", "group": "B", "groupLabel": "Second bracket", "label": "2nd bracket: number with x", "type": "number", "def": "1", "showIf": {"mode": ["double"]}}, {"id": "dbc", "group": "B", "label": "2nd bracket: number on its own", "type": "number", "def": "3", "showIf": {"mode": ["double"]}}], example: {"mode": "double", "k": 3, "sa": 2, "sb": -5, "dax": 1, "dac": 2, "dbx": 1, "dbc": 3}, run: (function (v, H) {
      function term(coef, letter) {
        if (coef === 0) return '';
        var mag = Math.abs(coef) === 1 && letter ? '' : H.fmt(Math.abs(coef));
        return (coef < 0 ? ' − ' : ' + ') + mag + letter;
      }
      function tidy(expr) {
        return expr.replace(/^ \+ /, '').replace(/^ − /, '−');
      }
      if (v.mode === 'single') {
        if (v.k === 0) throw new Error('With 0 outside the bracket everything vanishes. Use a non-zero k.');
        var t1 = v.k * v.sa, t2 = v.k * v.sb;
        var innerStr = tidy(term(v.sa, 'x') + term(v.sb, ''));
        var outStr = tidy(term(t1, 'x') + term(t2, ''));
        return {
          answer: outStr,
          steps: [
            'Multiply the outside number by EACH term inside: ' + H.fmt(v.k) + ' × ' + tidy(term(v.sa, 'x')) + ' = ' + tidy(term(t1, 'x')) + ', and ' + H.fmt(v.k) + ' × ' + tidy(term(v.sb, '')) + ' = ' + tidy(term(t2, '')),
            'So ' + H.fmt(v.k) + '(' + innerStr + ') = ' + outStr
          ]
        };
      }
      if (v.dax === 0 || v.dbx === 0) throw new Error('Each bracket needs an x term. For a plain-number bracket use the single bracket mode instead.');
      var xx = v.dax * v.dbx;
      var ox = v.dax * v.dbc;
      var ix = v.dac * v.dbx;
      var last = v.dac * v.dbc;
      var midCoef = ox + ix;
      function brk(m, n) {
        var xs = m === 1 ? 'x' : m === -1 ? '−x' : H.fmt(m) + 'x';
        return '(' + xs + (n === 0 ? '' : (n < 0 ? ' − ' : ' + ') + H.fmt(Math.abs(n))) + ')';
      }
      var sq = (xx === 1 ? '' : xx === -1 ? '−' : H.fmt(xx)) + 'x²';
      var result = tidy(' + ' + sq + term(midCoef, 'x') + term(last, ''));
      var steps = [
        'FOIL, four products in order: First ' + tidy(term(v.dax, 'x')) + ' × ' + tidy(term(v.dbx, 'x')) + ' = ' + sq + ', Outside ' + tidy(term(ox, 'x')) + ', Inside ' + tidy(term(ix, 'x')) + ', Last ' + H.fmt(v.dac) + ' × ' + H.fmt(v.dbc) + ' = ' + H.fmt(last),
        'Collect the two x terms: ' + tidy(term(ox, 'x')) + ' and ' + tidy(term(ix, 'x')) + ' make ' + tidy(term(midCoef, 'x') || ' + 0x'),
        'So ' + brk(v.dax, v.dac) + brk(v.dbx, v.dbc) + ' = ' + result
      ];
      return { answer: result, steps: steps };
    }), preview: (function (v, H) {
      function xn(m) { return m === '?' ? '?x' : Number(m) === 1 ? 'x' : Number(m) === -1 ? '−x' : m + 'x'; }
      function cn(n) { return n === '?' ? ' + ?' : Number(n) === 0 ? '' : Number(n) < 0 ? ' − ' + Math.abs(n) : ' + ' + n; }
      if (v.mode === 'single') return v.k + '(' + xn(v.sa) + cn(v.sb) + ')';
      return '(' + xn(v.dax) + cn(v.dac) + ')(' + xn(v.dbx) + cn(v.dbc) + ')';
    }) };
MC_CONFIG["factorising-calculator"] = { name: "Factorising Calculator", fields: [{"id": "mode", "label": "What to factorise", "type": "select", "def": "quad", "options": [["common", "Common factor: ax + b"], ["quad", "Quadratic: x\u00b2 + bx + c"]]}, {"id": "ca", "group": "C", "groupLabel": "The expression", "label": "The number with x (a)", "type": "number", "def": "8", "int": true, "showIf": {"mode": ["common"]}}, {"id": "cb", "group": "C", "label": "The number on its own (b)", "type": "number", "def": "12", "int": true, "showIf": {"mode": ["common"]}}, {"id": "qa", "group": "Q", "groupLabel": "The quadratic", "label": "a, the number with x\u00b2 (often 1)", "type": "number", "def": "1", "int": true, "min": 1, "max": 20, "showIf": {"mode": ["quad"]}}, {"id": "qb", "group": "Q", "label": "b, the number with x", "type": "number", "def": "5", "int": true, "showIf": {"mode": ["quad"]}}, {"id": "qc", "group": "Q", "label": "c, the number on its own", "type": "number", "def": "6", "int": true, "showIf": {"mode": ["quad"]}}], example: {"mode": "quad", "ca": 8, "cb": 12, "qa": 1, "qb": 5, "qc": 6}, run: (function (v, H) {
      function sgn(n) { return n < 0 ? ' − ' + H.fmt(-n) : ' + ' + H.fmt(n); }
      if (v.mode === 'common') {
        if (v.ca === 0 || v.cb === 0) throw new Error('Both terms need to be there. Use non-zero numbers for a and b.');
        var g = H.gcd(v.ca, v.cb);
        var exprC = H.fmt(v.ca) + 'x' + sgn(v.cb);
        if (g === 1) {
          return {
            answer: exprC + ' does not factorise (HCF is 1)',
            steps: [
              'Look for the highest common factor of ' + H.fmt(Math.abs(v.ca)) + ' and ' + H.fmt(Math.abs(v.cb)) + ': it is 1',
              'Nothing bigger than 1 divides both, so ' + exprC + ' is already as simple as it gets'
            ]
          };
        }
        var ia = v.ca / g, ib = v.cb / g;
        var inner = (ia === 1 ? 'x' : ia === -1 ? '−x' : H.fmt(ia) + 'x') + sgn(ib);
        var ansC = H.fmt(g) + '(' + inner + ')';
        return {
          answer: ansC,
          steps: [
            'Find the highest common factor of ' + H.fmt(Math.abs(v.ca)) + ' and ' + H.fmt(Math.abs(v.cb)) + ': it is ' + H.fmt(g),
            'Take ' + H.fmt(g) + ' outside and divide each term by it: ' + exprC + ' = ' + ansC,
            'Check by expanding: ' + H.fmt(g) + ' × ' + (ia === 1 ? 'x' : H.fmt(ia) + 'x') + ' and ' + H.fmt(g) + ' × ' + H.fmt(ib) + ' rebuild ' + exprC
          ]
        };
      }
      var a = v.qa, b = v.qb, c = v.qc;
      var exprQ = (a === 1 ? '' : H.fmt(a)) + 'x²'
        + (b === 0 ? '' : (b < 0 ? ' − ' : ' + ') + (Math.abs(b) === 1 ? '' : H.fmt(Math.abs(b))) + 'x')
        + (c === 0 ? '' : sgn(c));
      var ac = a * c;
      var found = null;
      if (ac === 0) {
        found = [0, b];
      } else {
        var limit = Math.abs(ac);
        for (var p = -limit; p <= limit; p++) {
          if (p === 0) continue;
          if (ac % p === 0) {
            var q = ac / p;
            if (p + q === b && p <= q) { found = [p, q]; break; }
          }
        }
      }
      if (!found) {
        return {
          answer: 'It does not factorise with whole numbers',
          steps: [
            'Multiply a × c: ' + H.fmt(a) + ' × ' + H.fmt(c) + ' = ' + H.fmt(ac) + ', then look for two whole numbers that multiply to ' + H.fmt(ac) + ' and add to ' + H.fmt(b),
            'No pair works, so ' + exprQ + ' will not split into neat brackets'
          ],
          note: 'It can still be solved. Use the Quadratic Equation Calculator, which handles the formula and surd answers.'
        };
      }
      var pp = found[0], qq = found[1];
      function red(m, n) {
        var g = n === 0 ? m : H.gcd(m, n);
        return [m / g, n / g, g];
      }
      function br(m, n) {
        var xs = m === 1 ? 'x' : H.fmt(m) + 'x';
        if (n === 0) return xs;
        return '(' + xs + (n < 0 ? ' − ' : ' + ') + H.fmt(Math.abs(n)) + ')';
      }
      var b1 = red(a, pp), b2 = red(a, qq);
      var k = b1[2] * b2[2] / a;
      var kStr = k === 1 ? '' : H.fmt(k);
      var ansQ = kStr + br(b1[0], b1[1]) + br(b2[0], b2[1]);
      var steps;
      if (a === 1) {
        steps = [
          'Look for two numbers that MULTIPLY to ' + H.fmt(c) + ' and ADD to ' + H.fmt(b) + ': ' + H.fmt(pp) + ' and ' + H.fmt(qq) + ' work, because ' + H.fmt(pp) + ' × ' + H.fmt(qq) + ' = ' + H.fmt(pp * qq) + ' and ' + H.fmt(pp) + ' + ' + H.fmt(qq) + ' = ' + H.fmt(pp + qq),
          'So ' + exprQ + ' = ' + ansQ,
          'Check by expanding: the x terms give ' + H.fmt(pp) + 'x + ' + H.fmt(qq) + 'x = ' + H.fmt(pp + qq) + 'x, and the numbers give ' + H.fmt(pp * qq) + ', matching c = ' + H.fmt(c)
        ];
      } else {
        var mid = (pp < 0 ? ' − ' : ' + ') + (Math.abs(pp) === 1 ? '' : H.fmt(Math.abs(pp))) + 'x'
          + (qq < 0 ? ' − ' : ' + ') + (Math.abs(qq) === 1 ? '' : H.fmt(Math.abs(qq))) + 'x';
        steps = [
          'a is not 1, so use the ac method. Multiply a × c: ' + H.fmt(a) + ' × ' + H.fmt(c) + ' = ' + H.fmt(ac),
          'Find two numbers that multiply to ' + H.fmt(ac) + ' and add to b = ' + H.fmt(b) + ': ' + H.fmt(pp) + ' and ' + H.fmt(qq),
          'Split the middle term with them: ' + (a === 1 ? '' : H.fmt(a)) + 'x²' + mid + (c === 0 ? '' : sgn(c)) + ', then factor each half and the shared bracket appears',
          'So ' + exprQ + ' = ' + ansQ,
          'Check by expanding ' + ansQ + ': the x² term gives ' + H.fmt(a) + 'x², the x terms collect to ' + H.fmt(b) + 'x, and the numbers give ' + H.fmt(c)
        ];
      }
      return { answer: ansQ, steps: steps };
    }), preview: (function (v, H) {
      if (v.mode === 'common') {
        return v.ca + 'x' + (v.cb === '?' ? ' + ?' : Number(v.cb) < 0 ? ' − ' + Math.abs(v.cb) : ' + ' + v.cb);
      }
      var aa = v.qa === '?' ? '?' : (Number(v.qa) === 1 ? '' : v.qa);
      var bb = v.qb === '?' ? ' + ?x' : Number(v.qb) === 0 ? '' : (Number(v.qb) < 0 ? ' − ' + Math.abs(v.qb) : ' + ' + Math.abs(v.qb)) + 'x';
      var cc = v.qc === '?' ? ' + ?' : Number(v.qc) === 0 ? '' : Number(v.qc) < 0 ? ' − ' + Math.abs(v.qc) : ' + ' + v.qc;
      return aa + 'x²' + bb + cc;
    }) };
MC_CONFIG["direct-and-inverse-proportion-calculator"] = { name: "Direct and Inverse Proportion Calculator", fields: [{"id": "mode", "label": "Relationship", "type": "select", "def": "direct", "options": [["direct", "Direct (y = k \u00d7 x)"], ["square", "Square (y = k \u00d7 x\u00b2)"], ["inverse", "Inverse (y = k \u00f7 x)"]]}, {"id": "x1", "label": "The x you know", "type": "number", "def": "2", "gt": 0}, {"id": "y1", "label": "Its matching y", "type": "number", "def": "6", "gt": 0}, {"id": "x2", "label": "Find y when x is", "type": "number", "def": "5", "gt": 0}], example: {"mode": "direct", "x1": 2, "y1": 6, "x2": 5}, run: (function (v, H) {
      var steps = [], k, y2, formula;
      if (v.mode === 'direct') {
        k = v.y1 / v.x1;
        formula = 'y = ' + H.fmt(k) + 'x';
        steps.push('Direct proportion means y = kx. Find k: k = y ÷ x = ' + H.fmt(v.y1) + ' ÷ ' + H.fmt(v.x1) + ' = ' + H.fmt(k));
        steps.push('Write the formula: ' + formula);
        y2 = k * v.x2;
        steps.push('Use it at x = ' + H.fmt(v.x2) + ': y = ' + H.fmt(k) + ' × ' + H.fmt(v.x2) + ' = ' + H.fmt(y2));
      } else if (v.mode === 'square') {
        k = v.y1 / (v.x1 * v.x1);
        formula = 'y = ' + H.fmt(k) + 'x²';
        steps.push('Proportional to the square means y = kx². Find k: k = y ÷ x² = ' + H.fmt(v.y1) + ' ÷ ' + H.fmt(v.x1 * v.x1) + ' = ' + H.fmt(k));
        steps.push('Write the formula: ' + formula);
        y2 = k * v.x2 * v.x2;
        steps.push('Use it at x = ' + H.fmt(v.x2) + ': y = ' + H.fmt(k) + ' × ' + H.fmt(v.x2 * v.x2) + ' = ' + H.fmt(y2));
      } else {
        k = v.y1 * v.x1;
        formula = 'y = ' + H.fmt(k) + ' ÷ x';
        steps.push('Inverse proportion means y = k ÷ x. Find k: k = y × x = ' + H.fmt(v.y1) + ' × ' + H.fmt(v.x1) + ' = ' + H.fmt(k));
        steps.push('Write the formula: ' + formula);
        y2 = k / v.x2;
        steps.push('Use it at x = ' + H.fmt(v.x2) + ': y = ' + H.fmt(k) + ' ÷ ' + H.fmt(v.x2) + ' = ' + H.fmt(y2));
      }
      return {
        answer: 'y = ' + H.fmt(y2), steps: steps,
        note: 'Sense check: ' + (v.mode === 'inverse' ? 'inverse means x up, y down.' : 'direct means x up, y up.') + ' Does the answer move the right way?'
      };
    }), preview: (function (v, H) {
      var rel = { direct: 'y ∝ x', square: 'y ∝ x²', inverse: 'y ∝ 1/x' }[v.mode];
      return rel + ',  y = ' + v.y1 + ' when x = ' + v.x1 + '.  y = ? when x = ' + v.x2;
    }) };
MC_CONFIG["fraction-of-amount-calculator"] = { name: "Fraction of an Amount Calculator", fields: [{"id": "n", "group": "F", "groupLabel": "The fraction", "slot": "num", "label": "Fraction top (numerator)", "type": "number", "def": "3", "gt": 0, "int": true}, {"id": "d", "group": "F", "slot": "den", "label": "Fraction bottom (denominator)", "type": "number", "def": "5", "gt": 0, "int": true}, {"id": "amount", "label": "The amount", "type": "number", "def": "45", "gt": 0}, {"id": "mode", "label": "Which way round", "type": "select", "def": "of", "options": [["of", "Find the fraction of it"], ["reverse", "Find the whole (reverse)"]]}], example: {"n": 3, "d": 5, "amount": 45, "mode": "of"}, run: (function (v, H) {
      if (v.mode === 'of') {
        var one = v.amount / v.d;
        var ans = one * v.n;
        return {
          answer: H.fmt(ans),
          steps: [
            'Divide by the bottom to find one part: ' + H.fmt(v.amount) + ' ÷ ' + H.fmt(v.d) + ' = ' + H.fmt(one),
            'Multiply by the top: ' + H.fmt(one) + ' × ' + H.fmt(v.n) + ' = ' + H.fmt(ans)
          ],
          note: 'Picture a bar cut into ' + H.fmt(v.d) + ' equal parts of ' + H.fmt(one) + ' each. You want ' + H.fmt(v.n) + ' of them.'
        };
      }
      var onePart = v.amount / v.n;
      var whole = onePart * v.d;
      return {
        answer: H.fmt(whole),
        steps: [
          H.fmt(v.amount) + ' covers ' + H.fmt(v.n) + ' ' + H.plural(v.n, 'part', 'parts') + ', so one part = ' + H.fmt(v.amount) + ' ÷ ' + H.fmt(v.n) + ' = ' + H.fmt(onePart),
          'The whole is all ' + H.fmt(v.d) + ' parts: ' + H.fmt(onePart) + ' × ' + H.fmt(v.d) + ' = ' + H.fmt(whole)
        ],
        note: 'Check it forwards: ' + H.frTok(v.n, v.d) + ' of ' + H.fmt(whole) + ' is ' + H.fmt(whole / v.d * v.n) + '.'
      };
    }), preview: (function (v, H) {
      return v.mode === 'of' ? H.frTok(v.n, v.d) + ' of ' + v.amount : H.frTok(v.n, v.d) + ' of ? = ' + v.amount;
    }), widget: (function (v, H) {
      var n = Number(v.n), d = Number(v.d), amt = Number(v.amount);
      if (!isFinite(n) || !isFinite(d) || !isFinite(amt) || d <= 0 || n <= 0 || amt <= 0) return '';
      var of = v.mode === 'of';
      var one = of ? amt / d : amt / n;
      var ans = of ? one * n : one * d;
      var barLine = '<p class="mc-rule-line"><span class="mc-rule-f">' +
        (of ? H.fmt(amt) + ' ÷ ' + H.fmt(d) + ' = ' + H.fmt(one) + ', then ' + H.fmt(one) + ' × ' + H.fmt(n) + ' = <b>' + H.fmt(ans) + '</b>'
            : H.fmt(amt) + ' ÷ ' + H.fmt(n) + ' = ' + H.fmt(one) + ', then ' + H.fmt(one) + ' × ' + H.fmt(d) + ' = <b>' + H.fmt(ans) + '</b>') +
        '</span><span class="mc-rule-why">' +
        (of ? 'Divide by the bottom, times by the top.' : 'Divide by the top for one share, times by the bottom for the whole.') +
        '</span></p>';
      if (!(Number.isInteger(n) && Number.isInteger(d) && n <= d && d <= 12)) return barLine;
      var cw = 420 / d, i, cells = '';
      for (i = 0; i < d; i++) {
        cells += '<rect class="mc-fb-cell' + (i < n ? ' is-a' : '') + '" x="' + (60 + i * cw).toFixed(1) + '" y="20" width="' + cw.toFixed(1) + '" height="44"></rect>';
        if (cw >= 38) cells += '<text class="mc-fb-fr" x="' + (60 + i * cw + cw / 2).toFixed(1) + '" y="46">' + H.fmt(one) + '</text>';
      }
      var bx1 = 63, bx2 = 60 + n * cw - 3;
      cells += '<path class="mc-fb-brk" d="M' + bx1 + ' 72v8h' + (bx2 - bx1).toFixed(1) + 'v-8"></path>' +
        '<text class="mc-fb-sub" x="' + ((bx1 + bx2) / 2).toFixed(1) + '" y="100" text-anchor="middle">' +
        (of ? H.fmt(n) + ' ' + H.plural(n, 'share', 'shares') + ' = ' + H.fmt(ans) : H.fmt(n) + ' ' + H.plural(n, 'share', 'shares') + ' = ' + H.fmt(amt) + ' (given)') + '</text>';
      var top = '<text class="mc-fb-sub" x="60" y="12">' +
        (of ? 'Split ' + H.fmt(amt) + ' into ' + H.fmt(d) + ' equal shares' : 'The whole is ' + H.fmt(d) + ' shares, and ' + H.fmt(n) + ' of them make ' + H.fmt(amt)) + '</text>';
      if (!of) cells += '<text class="mc-fb-sub" x="480" y="100" text-anchor="end">whole = ' + H.fmt(ans) + '</text>';
      return '<p class="mc-tri-hint">' + (of ? 'One bar, cut into equal shares: divide by the bottom, then take the top number of shares.' : 'Work backwards: the braced shares are what you were given, and the whole bar is the answer.') + '</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 110" style="max-width:640px" role="group" aria-label="Shares bar">' + top + cells + '</svg>' + barLine;
    }) };
MC_CONFIG["ordering-numbers-calculator"] = { name: "Ordering Numbers Calculator", fields: [{"id": "list", "label": "The numbers, any mix of forms", "type": "text", "def": "1/2, 0.45, 40%, 3/8", "hint": "Separate with commas. Fractions like 3/8, percentages like 40%."}, {"id": "dir", "label": "Order", "type": "select", "def": "asc", "options": [["asc", "Smallest first (ascending)"], ["desc", "Biggest first (descending)"]]}], example: {"list": "1/2, 0.45, 40%, 3/8", "dir": "asc"}, run: (function (v, H) {
      var raw = String(v.list).split(',').map(function (t) { return t.trim(); }).filter(function (t) { return t !== ''; });
      if (raw.length < 2) throw new Error('Enter at least two values, separated by commas.');
      if (raw.length > 12) throw new Error('Twelve values is plenty. Trim the list.');
      var items = [];
      for (var i = 0; i < raw.length; i++) {
        var tok = raw[i], val, how;
        var fm = tok.match(/^(\d+)\s*\/\s*(\d+)$/);
        if (fm) {
          if (Number(fm[2]) === 0) throw new Error('"' + tok + '" divides by zero.');
          val = Number(fm[1]) / Number(fm[2]);
          how = tok + ' = ' + fm[1] + ' ÷ ' + fm[2] + ' = ' + H.fmt(val);
        } else if (/%$/.test(tok)) {
          var p = Number(tok.replace('%', '').trim());
          if (!isFinite(p)) throw new Error('"' + tok + '" is not a number.');
          val = p / 100;
          how = tok + ' = ' + H.fmt(p) + ' ÷ 100 = ' + H.fmt(val);
        } else {
          val = Number(tok);
          if (!isFinite(val)) throw new Error('"' + tok + '" is not a fraction, decimal or percentage.');
          how = tok + ' stays as ' + H.fmt(val);
        }
        items.push({ tok: tok, val: val, how: how });
      }
      var steps = ['Convert everything to decimals so they can be compared fairly: ' + items.map(function (it) { return it.how; }).join('; ')];
      var sorted = items.slice().sort(function (a, b) { return v.dir === 'asc' ? a.val - b.val : b.val - a.val; });
      steps.push('Put the decimals in order: ' + sorted.map(function (it) { return H.fmt(it.val); }).join(', '));
      var ansList = sorted.map(function (it) { return it.tok; }).join(', ');
      steps.push('Write them back in their original forms: ' + ansList);
      return {
        answer: ansList, steps: steps,
        note: 'Always answer with the original forms, not the decimals. Copying the decimals over is a classic dropped mark.'
      };
    }), preview: (function (v, H) { return 'Order: ' + v.list + (v.dir === 'asc' ? ' (smallest first)' : ' (biggest first)'); }) };
MC_CONFIG["estimation-calculator"] = { name: "Estimation Calculator", fields: [{"id": "a", "label": "First number", "type": "number", "def": "347", "gt": 0}, {"id": "op", "label": "Operation", "type": "select", "def": "mul", "options": [["add", "Add (+)"], ["sub", "Subtract (\u2212)"], ["mul", "Multiply (\u00d7)"], ["div", "Divide (\u00f7)"]]}, {"id": "b", "label": "Second number", "type": "number", "def": "8.2", "gt": 0}], example: {"a": 347, "op": "mul", "b": 8.2}, run: (function (v, H) {
      function sf1(x) {
        var p = Math.pow(10, Math.floor(Math.log10(Math.abs(x))));
        return Math.round(x / p) * p;
      }
      var ra = sf1(v.a), rb = sf1(v.b);
      var sym = { add: '+', sub: '−', mul: '×', div: '÷' }[v.op];
      var est;
      if (v.op === 'add') est = ra + rb;
      else if (v.op === 'sub') est = ra - rb;
      else if (v.op === 'mul') est = ra * rb;
      else {
        if (rb === 0) throw new Error('The second number rounds to 0, and dividing by 0 is impossible. Estimation needs different numbers here.');
        est = ra / rb;
      }
      return {
        answer: '≈ ' + H.fmt(est),
        steps: [
          'Round each number to 1 significant figure: ' + H.fmt(v.a) + ' → ' + H.fmt(ra) + ' and ' + H.fmt(v.b) + ' → ' + H.fmt(rb),
          'Work with the friendly numbers: ' + H.fmt(ra) + ' ' + sym + ' ' + H.fmt(rb) + ' = ' + H.fmt(est)
        ],
        note: 'Write estimates with ≈, not =. The examiner wants to see the rounded numbers in your working, not just the final estimate.'
      };
    }), preview: (function (v, H) {
      var s = { add: '+', sub: '−', mul: '×', div: '÷' }[v.op];
      return v.a + ' ' + s + ' ' + v.b + ', estimated';
    }) };
MC_CONFIG["bounds-calculator"] = { name: "Bounds Calculator", fields: [{"id": "val", "label": "The rounded value", "type": "number", "def": "240", "keepRaw": true}, {"id": "acc", "label": "It was rounded to", "type": "select", "def": "10", "options": [["10", "The nearest 10"], ["100", "The nearest 100"], ["5", "The nearest 5"], ["whole", "The nearest whole number"], ["1dp", "1 decimal place"], ["2dp", "2 decimal places"]]}], example: {"val": 240, "acc": "10"}, run: (function (v, H) {
      var stepSize = { '10': 10, '100': 100, '5': 5, whole: 1, '1dp': 0.1, '2dp': 0.01 }[v.acc];
      var places = { '10': 0, '100': 0, '5': 1, whole: 1, '1dp': 2, '2dp': 3 }[v.acc];
      var half = stepSize / 2;
      var lb = v.val - half, ub = v.val + half;
      var lbS = H.commaStr(H.dp(lb, places));
      var ubS = H.commaStr(H.dp(ub, places));
      return {
        answer: 'Lower bound ' + lbS + ', upper bound ' + ubS,
        steps: [
          'The rounding step is ' + H.fmt(stepSize) + ', and anything within HALF a step rounds to the same place: half of ' + H.fmt(stepSize) + ' is ' + H.fmt(half),
          'Lower bound: ' + H.fmt(v.val) + ' − ' + H.fmt(half) + ' = ' + lbS,
          'Upper bound: ' + H.fmt(v.val) + ' + ' + H.fmt(half) + ' = ' + ubS
        ],
        note: 'Error interval: ' + lbS + ' ≤ value < ' + ubS + '. The top end takes < because a value exactly on the upper bound would round UP away from ' + H.fmt(v.val) + '.'
      };
    }), preview: (function (v, H) {
      var m = { '10': 'the nearest 10', '100': 'the nearest 100', '5': 'the nearest 5', whole: 'the nearest whole number', '1dp': '1 decimal place', '2dp': '2 decimal places' }[v.acc];
      return v.val + ', rounded to ' + m + '. True range = ?';
    }) };
MC_CONFIG["indices-calculator"] = { name: "Indices Calculator", fields: [{"id": "base", "label": "The base (the big number)", "type": "number", "def": "2", "gt": 0, "int": true, "max": 100}, {"id": "m", "label": "First power (m)", "type": "number", "def": "4", "int": true, "min": -12, "max": 12}, {"id": "n", "label": "Second power (n)", "type": "number", "def": "3", "int": true, "min": -12, "max": 12}, {"id": "law", "label": "Operation", "type": "select", "def": "mul", "options": [["mul", "Multiply: a\u1d50 \u00d7 a\u207f"], ["div", "Divide: a\u1d50 \u00f7 a\u207f"], ["pow", "Power of a power: (a\u1d50)\u207f"]]}], example: {"base": 2, "m": 4, "n": 3, "law": "mul"}, run: (function (v, H) {
      var e, lawLine, exprIn;
      if (v.law === 'mul') {
        e = v.m + v.n;
        exprIn = H.fmt(v.base) + H.sup(v.m) + ' × ' + H.fmt(v.base) + H.sup(v.n);
        lawLine = 'Same base multiplied: ADD the powers: ' + H.fmt(v.m) + ' + ' + H.fmt(v.n) + ' = ' + H.fmt(e);
      } else if (v.law === 'div') {
        e = v.m - v.n;
        exprIn = H.fmt(v.base) + H.sup(v.m) + ' ÷ ' + H.fmt(v.base) + H.sup(v.n);
        lawLine = 'Same base divided: SUBTRACT the powers: ' + H.fmt(v.m) + ' − ' + H.fmt(v.n) + ' = ' + H.fmt(e);
      } else {
        e = v.m * v.n;
        exprIn = '(' + H.fmt(v.base) + H.sup(v.m) + ')' + H.sup(v.n);
        lawLine = 'A power of a power: MULTIPLY the powers: ' + H.fmt(v.m) + ' × ' + H.fmt(v.n) + ' = ' + H.fmt(e);
      }
      var indexForm = H.fmt(v.base) + H.sup(e);
      var steps = [lawLine, 'So ' + exprIn + ' = ' + indexForm];
      var answer = indexForm;
      var note;
      if (e === 0) {
        steps.push('A power of 0 means the answer is 1: ' + indexForm + ' = 1');
        answer = indexForm + ' = 1';
      } else if (e > 0 && Math.pow(v.base, e) <= 1e12) {
        var val = Math.pow(v.base, e);
        steps.push('Evaluate it: ' + indexForm + ' = ' + H.fmt(val));
        answer = indexForm + ' = ' + H.fmt(val);
      } else if (e < 0 && Math.pow(v.base, -e) <= 1e12) {
        var den = Math.pow(v.base, -e);
        steps.push('A negative power means one over: ' + indexForm + ' = 1/' + H.fmt(v.base) + H.sup(-e) + ' = 1/' + H.fmt(den));
        answer = indexForm + ' = 1/' + H.fmt(den);
      } else {
        note = 'The number itself is huge, so leave the answer in index form.';
      }
      return { answer: answer, steps: steps, note: note };
    }), preview: (function (v, H) {
      if (v.law === 'mul') return v.base + H.sup(v.m) + ' × ' + v.base + H.sup(v.n);
      if (v.law === 'div') return v.base + H.sup(v.m) + ' ÷ ' + v.base + H.sup(v.n);
      return '(' + v.base + H.sup(v.m) + ')' + H.sup(v.n);
    }) };
MC_CONFIG["recurring-decimals-calculator"] = { name: "Recurring Decimals Calculator", fields: [{"id": "pre", "label": "Digits before the repeat (often none)", "type": "text", "def": "", "optional": true, "hint": "For 0.1666... this is 1. Leave empty for 0.3636..."}, {"id": "rep", "label": "The repeating digits", "type": "text", "def": "36", "hint": "For 0.3636... this is 36."}], example: {"pre": "", "rep": "36"}, run: (function (v, H) {
      var pre = String(v.pre || '').trim();
      var rep = String(v.rep || '').trim();
      if (!/^\d*$/.test(pre) || pre.length > 4) throw new Error('The before-the-repeat part must be 0 to 4 digits.');
      if (!/^\d+$/.test(rep) || rep.length > 6) throw new Error('The repeating part must be 1 to 6 digits.');
      if (/^0+$/.test(rep)) throw new Error('Repeating zeros is just a terminating decimal. Try the Fraction to Decimal Calculator.');
      var k = pre.length, r = rep.length;
      var shown = '0.' + pre + rep + rep + '...';
      var num = Number(pre + rep) - Number(pre === '' ? '0' : pre);
      var den = Math.pow(10, k + r) - Math.pow(10, k);
      var steps = ['Call the number x: x = ' + shown];
      if (k > 0) {
        steps.push('Multiply by 10' + H.sup(k) + ' to move past the non-repeating part: ' + H.fmt(Math.pow(10, k)) + 'x = ' + pre + '.' + rep + rep + '...');
      }
      steps.push('Multiply by 10' + H.sup(k + r) + ' so a whole repeat crosses the point: ' + H.fmt(Math.pow(10, k + r)) + 'x = ' + (pre + rep).replace(/^0+(?=\d)/, '') + '.' + rep + rep + '...');
      steps.push('Subtract the two lines, and the repeating tails cancel: ' + H.fmt(den) + 'x = ' + H.fmt(num));
      var g = H.gcd(num, den);
      var sn = num / g, sd = den / g;
      steps.push('Solve and simplify: x = ' + H.frTok(H.fmt(num), H.fmt(den)) + (g > 1 ? ' = ' + H.frTok(H.fmt(sn), H.fmt(sd)) : ''));
      return {
        answer: H.frTok(sn, sd),
        steps: steps,
        note: 'Check: ' + sn + ' ÷ ' + sd + ' = ' + H.fmt(sn / sd) + ', which matches ' + shown
      };
    }), preview: (function (v, H) {
      var pre = v.pre === '?' ? '' : v.pre;
      var rep = v.rep && v.rep !== '?' ? v.rep : '?';
      return '0.' + pre + rep + rep + rep + '... as a fraction';
    }) };
MC_CONFIG["sector-and-arc-calculator"] = { name: "Sector and Arc Calculator", fields: [{"id": "r", "label": "Radius", "type": "number", "def": "6", "gt": 0}, {"id": "angle", "label": "Angle of the sector (degrees)", "type": "number", "def": "90", "gt": 0, "max": 360}, {"id": "unit", "label": "Unit", "type": "select", "def": "cm", "options": [["cm", "Centimetres (cm)"], ["m", "Metres (m)"], ["mm", "Millimetres (mm)"]]}], example: {"r": 6, "angle": 90, "unit": "cm"}, run: (function (v, H) {
      var u = v.unit, sq = v.unit + '²';
      var frac = v.angle / 360;
      var arcCoef = v.angle * v.r / 180;
      var areaCoef = v.angle * v.r * v.r / 360;
      var arc = arcCoef * Math.PI;
      var area = areaCoef * Math.PI;
      var steps = [
        'The sector owns a fraction of the circle: ' + H.fmt(v.angle) + ' ÷ 360 = ' + H.fmt(frac),
        'Arc length = fraction × full circumference: ' + H.fmt(frac) + ' × 2π × ' + H.fmt(v.r) + ' = ' + H.fmt(arcCoef) + 'π = ' + H.fmt(arc) + ' ' + u,
        'Sector area = fraction × full area: ' + H.fmt(frac) + ' × π × ' + H.fmt(v.r) + '² = ' + H.fmt(areaCoef) + 'π = ' + H.fmt(area) + ' ' + sq
      ];
      return {
        answer: 'Arc ' + H.fmt(arcCoef) + 'π ' + u + ' (≈ ' + H.fmt(arc) + ' ' + u + '), area ' + H.fmt(areaCoef) + 'π ' + sq + ' (≈ ' + H.fmt(area) + ' ' + sq + ')',
        steps: steps,
        note: 'Perimeter of the whole sector = arc + two radii: ' + H.fmt(arc) + ' + ' + H.fmt(2 * v.r) + ' = ' + H.fmt(arc + 2 * v.r) + ' ' + u + '.'
      };
    }), preview: (function (v, H) { return 'A sector of ' + v.angle + '° from a circle with radius ' + v.r; }) };
MC_CONFIG["similar-shapes-calculator"] = { name: "Similar Shapes Calculator", fields: [{"id": "a", "label": "A length on the SMALL shape", "type": "number", "def": "8", "gt": 0}, {"id": "b", "label": "The matching length on the BIG shape", "type": "number", "def": "12", "gt": 0}, {"id": "known", "label": "Small-shape measurement to scale up", "type": "number", "def": "10", "gt": 0}, {"id": "type", "label": "That measurement is", "type": "select", "def": "area", "options": [["length", "A length"], ["area", "An area"], ["volume", "A volume"]]}], example: {"a": 8, "b": 12, "known": 10, "type": "area"}, run: (function (v, H) {
      var sf = v.b / v.a;
      var steps = ['Scale factor from small to big: ' + H.fmt(v.b) + ' ÷ ' + H.fmt(v.a) + ' = ' + H.fmt(sf)];
      var power, powered;
      if (v.type === 'length') {
        power = ''; powered = sf;
        steps.push('Lengths scale by the plain scale factor: ' + H.fmt(sf));
      } else if (v.type === 'area') {
        power = '²'; powered = sf * sf;
        steps.push('Areas have two dimensions, so they scale by SF²: ' + H.fmt(sf) + '² = ' + H.fmt(powered));
      } else {
        power = '³'; powered = sf * sf * sf;
        steps.push('Volumes have three dimensions, so they scale by SF³: ' + H.fmt(sf) + '³ = ' + H.fmt(powered));
      }
      var ans = v.known * powered;
      steps.push('Multiply: ' + H.fmt(v.known) + ' × ' + H.fmt(powered) + ' = ' + H.fmt(ans));
      return {
        answer: H.fmt(ans), steps: steps,
        note: 'Going from big down to small, divide by SF' + power + ' instead. Units: the answer keeps the units of the measurement you scaled.'
      };
    }), preview: (function (v, H) {
      return 'Lengths ' + v.a + ' → ' + v.b + '. Scale ' + (v.type === '?' ? '?' : 'the ' + v.type) + ' ' + v.known + ' up';
    }) };
MC_CONFIG["sine-and-cosine-rule-calculator"] = { name: "Sine and Cosine Rule Calculator", fields: [{"id": "mode", "label": "What you know and want", "type": "select", "def": "sineside", "cls": "mc-ghost", "options": [["sineside", "Sine rule: find a side"], ["sineangle", "Sine rule: find an angle"], ["cosside", "Cosine rule: find a side"], ["cosangle", "Cosine rule: find an angle"]]}, {"id": "A", "label": "Angle A (degrees)", "type": "number", "def": "40", "min": 0, "max": 180, "showIf": {"mode": ["sineside", "cosside"]}}, {"id": "B", "label": "Angle B (degrees)", "type": "number", "def": "70", "min": 0, "max": 180, "showIf": {"mode": ["sineside", "sineangle"]}}, {"id": "a", "label": "Side a (opposite A)", "type": "number", "def": "6", "min": 0, "showIf": {"mode": ["sineangle", "cosangle"]}}, {"id": "b", "label": "Side b (opposite B)", "type": "number", "def": "8", "min": 0}, {"id": "cc", "label": "Side c", "type": "number", "def": "7", "min": 0, "showIf": {"mode": ["cosside", "cosangle"]}}], example: {"mode": "sineside", "A": 40, "B": 70, "a": 0, "b": 8, "cc": 0}, run: (function (v, H) {
      var D = Math.PI / 180;
      var steps = [];
      if (v.mode === 'sineside') {
        if (v.A <= 0 || v.B <= 0 || v.A + v.B >= 180) throw new Error('Angles A and B must each be above 0 and add to less than 180.');
        if (v.b <= 0) throw new Error('Side b is needed (bigger than 0).');
        var aa = Math.sin(v.A * D) * v.b / Math.sin(v.B * D);
        steps.push('The sine rule pairs sides with their opposite angles: a ÷ sin A = b ÷ sin B');
        steps.push('Rearrange for a: a = b × sin A ÷ sin B = ' + H.fmt(v.b) + ' × sin(' + H.fmt(v.A) + '°) ÷ sin(' + H.fmt(v.B) + '°)');
        steps.push('Evaluate: ' + H.fmt(v.b) + ' × ' + H.fmt(Math.sin(v.A * D)) + ' ÷ ' + H.fmt(Math.sin(v.B * D)) + ' = ' + H.fmt(aa));
        return { answer: H.fmt(aa), steps: steps, note: 'Same unit as side b. Calculator in degrees mode when checking by hand.' };
      }
      if (v.mode === 'sineangle') {
        if (v.a <= 0 || v.b <= 0) throw new Error('Sides a and b are both needed (bigger than 0).');
        if (v.B <= 0 || v.B >= 180) throw new Error('Angle B must be between 0 and 180.');
        var sinA = v.a * Math.sin(v.B * D) / v.b;
        if (sinA > 1) throw new Error('That combination is impossible: it would need sin A above 1. Check which side faces which angle.');
        var Aang = Math.asin(sinA) / D;
        steps.push('The sine rule with the angles on top: sin A ÷ a = sin B ÷ b');
        steps.push('Rearrange: sin A = a × sin B ÷ b = ' + H.fmt(v.a) + ' × ' + H.fmt(Math.sin(v.B * D)) + ' ÷ ' + H.fmt(v.b) + ' = ' + H.fmt(sinA));
        steps.push('Undo with inverse sine: A = sin⁻¹(' + H.fmt(sinA) + ') = ' + H.fmt(Aang) + '°');
        return { answer: H.fmt(Aang) + '°', steps: steps, note: 'If the triangle could be obtuse at A, the other possibility is 180° − ' + H.fmt(Aang) + '° = ' + H.fmt(180 - Aang) + '° (the ambiguous case).' };
      }
      if (v.mode === 'cosside') {
        if (v.b <= 0 || v.cc <= 0) throw new Error('Sides b and c are both needed (bigger than 0).');
        if (v.A <= 0 || v.A >= 180) throw new Error('Angle A must be between 0 and 180.');
        var a2 = v.b * v.b + v.cc * v.cc - 2 * v.b * v.cc * Math.cos(v.A * D);
        var aside = Math.sqrt(a2);
        steps.push('Two sides and the angle BETWEEN them: cosine rule, a² = b² + c² − 2bc cos A');
        steps.push('Substitute: a² = ' + H.fmt(v.b * v.b) + ' + ' + H.fmt(v.cc * v.cc) + ' − 2 × ' + H.fmt(v.b) + ' × ' + H.fmt(v.cc) + ' × ' + H.fmt(Math.cos(v.A * D)) + ' = ' + H.fmt(a2));
        steps.push('Square root: a = √' + H.fmt(a2) + ' = ' + H.fmt(aside));
        return { answer: H.fmt(aside), steps: steps };
      }
      if (v.a <= 0 || v.b <= 0 || v.cc <= 0) throw new Error('All three sides are needed (each bigger than 0).');
      if (v.a >= v.b + v.cc || v.b >= v.a + v.cc || v.cc >= v.a + v.b) throw new Error('Those three lengths cannot make a triangle: one side is as long as the other two together.');
      var cosA = (v.b * v.b + v.cc * v.cc - v.a * v.a) / (2 * v.b * v.cc);
      var Aa = Math.acos(cosA) / D;
      steps.push('All three sides known: cosine rule rearranged, cos A = (b² + c² − a²) ÷ 2bc');
      steps.push('Substitute: cos A = (' + H.fmt(v.b * v.b) + ' + ' + H.fmt(v.cc * v.cc) + ' − ' + H.fmt(v.a * v.a) + ') ÷ ' + H.fmt(2 * v.b * v.cc) + ' = ' + H.fmt(cosA));
      steps.push('Undo with inverse cos: A = cos⁻¹(' + H.fmt(cosA) + ') = ' + H.fmt(Aa) + '°');
      return { answer: H.fmt(Aa) + '°', steps: steps };
    }), preview: (function (v, H) {
      if (v.mode === 'sineside') return 'A = ' + v.A + '°, B = ' + v.B + '°, b = ' + v.b + '.  a = ?';
      if (v.mode === 'sineangle') return 'a = ' + v.a + ', b = ' + v.b + ', B = ' + v.B + '°.  A = ?';
      if (v.mode === 'cosside') return 'b = ' + v.b + ', c = ' + v.cc + ', A = ' + v.A + '°.  a = ?';
      return 'a = ' + v.a + ', b = ' + v.b + ', c = ' + v.cc + '.  A = ?';
    }), widget: (function (v, H) {
      var side = v.mode === 'sineside' || v.mode === 'cosside';
      var sine = v.mode === 'sineside' || v.mode === 'sineangle';
      var el = H.triEl;
      var D = Math.PI / 180;
      var A1 = Number(v.A), B1 = Number(v.B), a1 = Number(v.a), b1 = Number(v.b), c1 = Number(v.cc);
      /* v2 (2026-08-19): solve the triangle from whatever this mode knows,
         then DRAW that triangle, so the angles on screen are the real ones.
         ans = the value being found, Ad/Bd = the base angles to draw. */
      var ans = null, Ad = null, Bd = null, rv = null;
      if (v.mode === 'sineside') {
        if (A1 > 0 && B1 > 0 && A1 + B1 < 180 && b1 > 0) {
          ans = Math.sin(A1 * D) * b1 / Math.sin(B1 * D);
          Ad = A1; Bd = B1;
        }
      } else if (v.mode === 'sineangle') {
        if (a1 > 0 && b1 > 0 && B1 > 0 && B1 < 180) {
          rv = a1 * Math.sin(B1 * D) / b1;
          if (rv <= 1) { ans = Math.asin(rv) / D; Ad = ans; Bd = B1; }
        }
      } else if (v.mode === 'cosside') {
        if (b1 > 0 && c1 > 0 && A1 > 0 && A1 < 180) {
          var a2v = b1 * b1 + c1 * c1 - 2 * b1 * c1 * Math.cos(A1 * D);
          ans = Math.sqrt(a2v);
          Ad = A1; Bd = Math.acos((a2v + c1 * c1 - b1 * b1) / (2 * ans * c1)) / D;
        }
      } else {
        if (a1 > 0 && b1 > 0 && c1 > 0 && a1 < b1 + c1 && b1 < a1 + c1 && c1 < a1 + b1) {
          rv = (b1 * b1 + c1 * c1 - a1 * a1) / (2 * b1 * c1);
          ans = Math.acos(rv) / D;
          Ad = ans; Bd = Math.acos((a1 * a1 + c1 * c1 - b1 * b1) / (2 * a1 * c1)) / D;
        }
      }
      /* drawable shape: fall back to the canonical 40/70 triangle when the
         inputs are incomplete, impossible, or too flat to read */
      var valid = ans !== null, capped = !valid;
      var dA = valid ? Ad : 40, dB = valid ? Bd : 70;
      if (dA < 14 || dB < 14 || 180 - dA - dB < 14) { dA = 40; dB = 70; capped = true; }
      dA = dA > 90 ? Math.max(dA, 91) : Math.min(dA, 89);
      dB = dB > 90 ? Math.max(dB, 91) : Math.min(dB, 89);
      var tA = Math.tan(dA * D), tB = Math.tan(dB * D);
      var hh = tA * tB / (tA + tB);
      var ax0 = hh / tA;
      var minX = Math.min(0, ax0), maxX = Math.max(1, ax0);
      var s = Math.min(360 / (maxX - minX), 168 / hh);
      var oy = 224;
      var AX = Math.round((600 - (maxX - minX) * s) / 2 - minX * s);
      var BX = Math.round(AX + s);
      var CX = Math.round(AX + ax0 * s), CY = Math.round(oy - hh * s);
      function ln(x1, y1, x2, y2) {
        return '<line class="mc-tri-hit" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"></line>' +
          '<line class="mc-tri-line" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"></line>';
      }
      var aTxt = side ? (valid ? H.fmt(ans) : '?') : (isFinite(a1) ? H.fmt(a1) : v.a);
      var ATxt = side ? (isFinite(A1) ? H.fmt(A1) : v.A) + '°' : (valid ? H.fmt(ans) + '°' : '?');
      /* chips sit on their line mids; angle chips sit on the bisector so
         they stay inside whatever shape the triangle takes */
      var hA2 = dA / 2 * D, hB2 = dB / 2 * D;
      var aEl = el(Math.round((BX + CX) / 2), Math.round((oy + CY) / 2), 'a = ' + aTxt, side ? 'find' : 'known',
        'mode:' + v.mode, sine ? 'mode:sineside' : 'mode:cosside',
        side ? 'Side a is the one being found' : 'Side a is known',
        'Find side a', ln(BX, oy, CX, CY));
      var bEl = el(Math.round((AX + CX) / 2), Math.round((oy + CY) / 2), 'b = ' + (isFinite(b1) ? H.fmt(b1) : v.b), 'known',
        'mode:' + v.mode, '', 'Side b is known, both rules use it', '', ln(AX, oy, CX, CY));
      var cEl = el(Math.round((AX + BX) / 2), oy + 22, sine ? 'c' : 'c = ' + (isFinite(c1) ? H.fmt(c1) : v.cc), sine ? 'idle' : 'known',
        side ? 'mode:cosside' : 'mode:cosangle', '',
        'Mark side c as known and use the cosine rule', '', ln(AX, oy, BX, oy));
      var AEl = el(Math.round(AX + 66 * Math.cos(hA2)), Math.round(oy - 48 * Math.sin(hA2)), 'A = ' + ATxt, side ? 'known' : 'find',
        'mode:' + v.mode, sine ? 'mode:sineangle' : 'mode:cosangle',
        side ? 'Angle A is known' : 'Angle A is the one being found',
        'Find angle A', '');
      var BEl = el(Math.round(BX - 66 * Math.cos(hB2)), Math.round(oy - 48 * Math.sin(hB2)), sine ? 'B = ' + (isFinite(B1) ? H.fmt(B1) : v.B) + '°' : 'B', sine ? 'known' : 'idle',
        side ? 'mode:sineside' : 'mode:sineangle', '',
        'Mark angle B as known and use the sine rule', '', '');
      var arcA = 'M' + (AX + 26) + ' ' + oy + 'A26 26 0 0 0 ' + (AX + 26 * Math.cos(dA * D)).toFixed(1) + ' ' + (oy - 26 * Math.sin(dA * D)).toFixed(1);
      var arcB = 'M' + (BX - 26 * Math.cos(dB * D)).toFixed(1) + ' ' + (oy - 26 * Math.sin(dB * D)).toFixed(1) + 'A26 26 0 0 0 ' + (BX - 26) + ' ' + oy;
      /* the rule is the whole lesson here, so it gets its own switch and a
         live formula line with the numbers substituted once they exist */
      var formula, why;
      if (v.mode === 'sineside') {
        formula = valid
          ? '<b>a</b> = ' + H.fmt(b1) + ' × sin(' + H.fmt(A1) + '°) ÷ sin(' + H.fmt(B1) + '°) = <b>' + H.fmt(ans) + '</b>'
          : '<b>a</b> ÷ sin A = b ÷ sin B';
      } else if (v.mode === 'sineangle') {
        formula = valid
          ? 'sin <b>A</b> = ' + H.fmt(a1) + ' × sin(' + H.fmt(B1) + '°) ÷ ' + H.fmt(b1) + ' = ' + H.fmt(rv) + ', so A = <b>' + H.fmt(ans) + '°</b>'
          : 'sin <b>A</b> ÷ a = sin B ÷ b';
      } else if (v.mode === 'cosside') {
        formula = valid
          ? '<b>a</b>² = ' + H.fmt(b1 * b1 + c1 * c1) + ' − ' + H.fmt(2 * b1 * c1) + ' × cos(' + H.fmt(A1) + '°) = ' + H.fmt(ans * ans) + ', so a = <b>' + H.fmt(ans) + '</b>'
          : '<b>a</b>² = b² + c² − 2bc cos A';
      } else {
        formula = valid
          ? 'cos <b>A</b> = (' + H.fmt(b1 * b1) + ' + ' + H.fmt(c1 * c1) + ' − ' + H.fmt(a1 * a1) + ') ÷ ' + H.fmt(2 * b1 * c1) + ' = ' + H.fmt(rv) + ', so A = <b>' + H.fmt(ans) + '°</b>'
          : 'cos <b>A</b> = (b² + c² − a²) ÷ 2bc';
      }
      why = sine ? 'For a side and its opposite angle in matching pairs'
        : 'For two sides with the angle between them, or all three sides';
      var tabs = '<div class="mc-rule-tabs" role="group" aria-label="Which rule">' +
        '<button type="button" class="mc-rule-tab' + (sine ? ' is-on' : '') + '" data-mc-tap data-set="mode:' + (side ? 'sineside' : 'sineangle') + '" aria-pressed="' + sine + '">Sine rule</button>' +
        '<button type="button" class="mc-rule-tab' + (sine ? '' : ' is-on') + '" data-mc-tap data-set="mode:' + (side ? 'cosside' : 'cosangle') + '" aria-pressed="' + !sine + '">Cosine rule</button>' +
        '</div>' +
        '<p class="mc-rule-line is-' + (sine ? 'sine' : 'cos') + '"><span class="mc-rule-f">' + formula + '</span><span class="mc-rule-why">' + why + '</span></p>';
      return tabs +
        '<p class="mc-tri-hint">The triangle is drawn with the real angles, so you can sanity-check by eye: the biggest angle faces the longest side. Tap a <span class="mc-tri-q">?</span> to choose what to find.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 268" role="group" aria-label="Triangle ABC drawn from your numbers, tap the sides and angles to choose the rule">' +
        '<path class="mc-tri-face" d="M' + AX + ' ' + oy + 'L' + BX + ' ' + oy + 'L' + CX + ' ' + CY + 'Z"></path>' +
        '<path class="mc-tri-arc is-' + (side ? 'known' : 'find') + '" d="' + arcA + '"></path>' +
        '<path class="mc-tri-arc is-' + (sine ? 'known' : 'idle') + '" d="' + arcB + '"></path>' +
        '<text class="mc-tri-vtx" x="' + CX + '" y="' + (CY - 13) + '">C</text>' +
        '<text class="mc-tri-scale" x="592" y="264" text-anchor="end">' + (capped ? 'not to scale' : 'drawn to scale') + '</text>' +
        cEl + bEl + aEl + AEl + BEl + '</svg>';
    }) };
MC_CONFIG["surds-calculator"] = { name: "Surds Calculator", fields: [{"id": "mode", "label": "What to do", "type": "select", "def": "simplify", "options": [["simplify", "Simplify \u221an"], ["multiply", "Multiply: \u221aa \u00d7 \u221ab"], ["rationalise", "Rationalise: k \u00f7 \u221aa"]]}, {"id": "A", "label": "n or a (under the root)", "type": "number", "def": "48", "gt": 0, "int": true, "max": 100000}, {"id": "B", "label": "The other number (b or k)", "type": "number", "def": "1", "gt": 0, "int": true, "max": 100000, "showIf": {"mode": ["multiply", "rationalise"]}}], example: {"mode": "simplify", "A": 48, "B": 1}, run: (function (v, H) {
      function simp(n) {
        var s = Math.floor(Math.sqrt(n)), best = 1;
        for (var k = s; k >= 2; k--) { if (n % (k * k) === 0) { best = k; break; } }
        return [best, n / (best * best)];
      }
      function surdStr(coef, inner) {
        if (inner === 1) return H.fmt(coef);
        return (coef === 1 ? '' : H.fmt(coef)) + '√' + H.fmt(inner);
      }
      var steps = [];
      if (v.mode === 'simplify') {
        var sp = simp(v.A);
        if (sp[1] === 1) {
          steps.push(H.fmt(v.A) + ' is a square number: ' + H.fmt(sp[0]) + ' × ' + H.fmt(sp[0]) + ' = ' + H.fmt(v.A));
          steps.push('So √' + H.fmt(v.A) + ' = ' + H.fmt(sp[0]));
          return { answer: H.fmt(sp[0]), steps: steps };
        }
        if (sp[0] === 1) {
          steps.push(H.fmt(v.A) + ' has no square factors bigger than 1');
          steps.push('So √' + H.fmt(v.A) + ' is already in its simplest form: √' + H.fmt(v.A));
          return { answer: '√' + H.fmt(v.A), steps: steps, note: 'As a decimal, ≈ ' + H.fmt(Math.sqrt(v.A)) + '.' };
        }
        steps.push('Find the biggest square factor: ' + H.fmt(v.A) + ' = ' + H.fmt(sp[0] * sp[0]) + ' × ' + H.fmt(sp[1]));
        steps.push('Split the root: √' + H.fmt(v.A) + ' = √' + H.fmt(sp[0] * sp[0]) + ' × √' + H.fmt(sp[1]) + ' = ' + surdStr(sp[0], sp[1]));
        return { answer: surdStr(sp[0], sp[1]), steps: steps, note: 'As a decimal, ≈ ' + H.fmt(Math.sqrt(v.A)) + '.' };
      }
      if (v.mode === 'multiply') {
        var prod = v.A * v.B;
        steps.push('Roots multiply under one roof: √' + H.fmt(v.A) + ' × √' + H.fmt(v.B) + ' = √' + H.fmt(prod));
        var mp = simp(prod);
        var ansM = surdStr(mp[0], mp[1]);
        if (mp[1] === 1) steps.push('√' + H.fmt(prod) + ' is exact: ' + ansM);
        else if (mp[0] > 1) steps.push('Simplify: ' + H.fmt(prod) + ' = ' + H.fmt(mp[0] * mp[0]) + ' × ' + H.fmt(mp[1]) + ', so √' + H.fmt(prod) + ' = ' + ansM);
        else steps.push('√' + H.fmt(prod) + ' has no square factors, so it stays as √' + H.fmt(prod));
        return { answer: ansM, steps: steps };
      }
      var k2 = v.B;
      steps.push('Multiply top and bottom by √' + H.fmt(v.A) + ' (that is just multiplying by 1): ' + H.frTok(H.fmt(k2), '√' + H.fmt(v.A)) + ' = ' + H.frTok(H.fmt(k2) + '√' + H.fmt(v.A), H.fmt(v.A)));
      var g = H.gcd(k2, v.A);
      var topC = k2 / g, botC = v.A / g;
      var sp2 = simp(v.A);
      var ansR;
      if (g > 1) {
        steps.push('Cancel the common factor ' + H.fmt(g) + ': ' + (topC === 1 ? '' : H.fmt(topC)) + '√' + H.fmt(v.A) + (botC === 1 ? '' : ' ÷ ' + H.fmt(botC)));
      }
      var numR = (topC === 1 ? '' : H.fmt(topC)) + '√' + H.fmt(v.A);
      ansR = botC === 1 ? numR : H.frTok(numR, H.fmt(botC));
      steps.push('So ' + H.frTok(H.fmt(k2), '√' + H.fmt(v.A)) + ' = ' + ansR);
      var out = { answer: ansR, steps: steps };
      if (sp2[0] > 1) out.note = '√' + H.fmt(v.A) + ' itself simplifies to ' + surdStr(sp2[0], sp2[1]) + ', so the answer can be tidied further if the question asks for simplest form.';
      return out;
    }), preview: (function (v, H) {
      if (v.mode === 'simplify') return '√' + v.A;
      if (v.mode === 'multiply') return '√' + v.A + ' × √' + v.B;
      return v.B + ' ÷ √' + v.A;
    }) };
MC_CONFIG["averages-from-a-table-calculator"] = { name: "Averages from a Table Calculator", fields: [{"id": "xs", "label": "The values (x)", "type": "text", "def": "1, 2, 3, 4", "hint": "For example goals scored, or pets owned."}, {"id": "fs", "label": "The frequencies (f), same order", "type": "text", "def": "3, 5, 8, 4", "hint": "How many people gave each value."}], example: {"xs": "1, 2, 3, 4", "fs": "3, 5, 8, 4"}, run: (function (v, H) {
      function parse(s, name) {
        var out = String(s).trim().split(/[\s,]+/).filter(function (t) { return t !== ''; }).map(Number);
        for (var i = 0; i < out.length; i++) { if (!isFinite(out[i])) throw new Error('The ' + name + ' list has something that is not a number.'); }
        return out;
      }
      var xs = parse(v.xs, 'values'), fs = parse(v.fs, 'frequencies');
      if (xs.length !== fs.length) throw new Error('The two lists must be the same length: ' + xs.length + ' values but ' + fs.length + ' frequencies.');
      if (xs.length < 2) throw new Error('Give at least two rows of the table.');
      if (xs.length > 15) throw new Error('Fifteen rows is plenty.');
      var sumF = 0, sumFX = 0, fxParts = [];
      for (var i = 0; i < xs.length; i++) {
        if (fs[i] < 0 || !Number.isInteger(fs[i])) throw new Error('Frequencies must be whole numbers, 0 or more.');
        sumF += fs[i];
        sumFX += xs[i] * fs[i];
        fxParts.push(H.fmt(xs[i]) + '×' + H.fmt(fs[i]) + '=' + H.fmt(xs[i] * fs[i]));
      }
      if (sumF === 0) throw new Error('Every frequency is 0, so there is no data.');
      var steps = [
        'Build the fx row (value × how many of it): ' + fxParts.join(', '),
        'Totals: Σf = ' + H.fmt(sumF) + ' pieces of data, and Σfx = ' + H.fmt(sumFX),
        'Mean = Σfx ÷ Σf: ' + H.fmt(sumFX) + ' ÷ ' + H.fmt(sumF) + ' = ' + H.fmt(sumFX / sumF)
      ];
      var pos = (sumF + 1) / 2;
      var med;
      var cum = 0, at = [];
      for (var j = 0; j < xs.length; j++) { cum += fs[j]; at.push(cum); }
      function valueAt(p) {
        for (var k = 0; k < at.length; k++) { if (p <= at[k]) return xs[k]; }
        return xs[xs.length - 1];
      }
      if (Number.isInteger(pos)) {
        med = valueAt(pos);
        steps.push('Median: the middle piece of data is the ' + H.fmt(pos) + 'th. Counting up the frequencies lands it on ' + H.fmt(med));
      } else {
        var lo = valueAt(Math.floor(pos)), hi = valueAt(Math.ceil(pos));
        med = (lo + hi) / 2;
        steps.push('Median: the middle sits between the ' + H.fmt(Math.floor(pos)) + 'th and ' + H.fmt(Math.ceil(pos)) + 'th pieces, values ' + H.fmt(lo) + ' and ' + H.fmt(hi) + ', so it is ' + H.fmt(med));
      }
      var maxF = Math.max.apply(null, fs);
      var modes = [];
      for (var mIdx = 0; mIdx < xs.length; mIdx++) { if (fs[mIdx] === maxF) modes.push(H.fmt(xs[mIdx])); }
      var modeStr = maxF === 0 ? 'none' : modes.join(' and ');
      steps.push('Mode: the biggest frequency is ' + H.fmt(maxF) + ', belonging to ' + modeStr);
      return {
        answer: 'Mean ' + H.fmt(sumFX / sumF) + ', median ' + H.fmt(med) + ', mode ' + modeStr,
        steps: steps,
        note: 'The classic slip: dividing Σfx by the number of ROWS instead of Σf. There are ' + H.fmt(sumF) + ' pieces of data here, not ' + xs.length + '.'
      };
    }), preview: (function (v, H) { return 'Values: ' + v.xs + '  with frequencies: ' + v.fs; }) };
MC_CONFIG["interquartile-range-calculator"] = { name: "Interquartile Range Calculator", fields: [{"id": "values", "label": "Your numbers", "type": "text", "def": "2, 4, 5, 7, 8, 9, 11", "hint": "Between 4 and 30 numbers, commas between them."}], example: {"values": "2, 4, 5, 7, 8, 9, 11"}, run: (function (v, H) {
      var raw = String(v.values).trim().split(/[\s,]+/).filter(function (t) { return t !== ''; });
      var nums = [];
      for (var i = 0; i < raw.length; i++) {
        var n = Number(raw[i]);
        if (!isFinite(n)) throw new Error('"' + raw[i] + '" is not a number.');
        nums.push(n);
      }
      if (nums.length < 4) throw new Error('Quartiles need at least four numbers.');
      if (nums.length > 30) throw new Error('Thirty numbers is plenty.');
      var a = nums.slice().sort(function (x, y) { return x - y; });
      var N = a.length;
      function q(k) {
        var pos = k * (N + 1) / 4;
        var lo = Math.floor(pos), frac = pos - lo;
        if (lo < 1) return { pos: pos, val: a[0] };
        if (lo >= N) return { pos: pos, val: a[N - 1] };
        return { pos: pos, val: a[lo - 1] + frac * (a[lo] - a[lo - 1]) };
      }
      var q1 = q(1), q2 = q(2), q3 = q(3);
      var iqr = q3.val - q1.val;
      var steps = [
        'Order the ' + N + ' numbers: ' + a.map(H.fmt).join(', '),
        'Quartile positions with the (n + 1) rule: Q1 at ' + H.fmt(q1.pos) + ', Q2 at ' + H.fmt(q2.pos) + ', Q3 at ' + H.fmt(q3.pos),
        'Read them off: Q1 = ' + H.fmt(q1.val) + ', Q2 (the median) = ' + H.fmt(q2.val) + ', Q3 = ' + H.fmt(q3.val),
        'Interquartile range = Q3 − Q1: ' + H.fmt(q3.val) + ' − ' + H.fmt(q1.val) + ' = ' + H.fmt(iqr)
      ];
      return {
        answer: 'Q1 ' + H.fmt(q1.val) + ', median ' + H.fmt(q2.val) + ', Q3 ' + H.fmt(q3.val) + ', IQR ' + H.fmt(iqr),
        steps: steps,
        note: 'The IQR describes the middle half of the data, so one freak value cannot distort it, unlike the range.'
      };
    }), preview: (function (v, H) { return 'The data: ' + v.values; }) };
MC_CONFIG["time-calculator"] = { name: "Time Calculator", fields: [{"id": "mode", "label": "What to do", "type": "select", "def": "between", "cls": "mc-ghost", "options": [["between", "Time between two times"], ["add", "Add a duration to a time"], ["mul", "Multiply a duration"], ["pct", "Percentage of a time"]]}, {"id": "h1", "label": "Start hour (24-hour clock)", "type": "number", "def": "14", "min": 0, "max": 23, "int": true, "group": "a", "groupLabel": "Start time", "slot": "hr"}, {"id": "m1", "label": "Start minutes", "type": "number", "def": "45", "min": 0, "max": 59, "int": true, "group": "a", "slot": "mn", "sep": ":"}, {"id": "arrow", "label": "", "type": "static", "text": "\u2192", "slot": "op", "showIf": {"mode": ["between", "add"]}}, {"id": "h2", "label": "End hour, or hours to add", "type": "number", "def": "17", "min": 0, "max": 23, "int": true, "group": "b", "groupLabel": "End time", "slot": "hr", "showIf": {"mode": ["between", "add"]}}, {"id": "m2", "label": "End minutes, or minutes to add", "type": "number", "def": "20", "min": 0, "max": 59, "int": true, "group": "b", "slot": "mn", "sep": ":", "showIf": {"mode": ["between", "add"]}}, {"id": "mulop", "label": "", "type": "static", "text": "\u00d7", "slot": "op", "showIf": {"mode": ["mul"]}}, {"id": "mult", "label": "Multiply by", "type": "number", "def": "2", "gt": 0, "max": 1000, "showIf": {"mode": ["mul"]}}, {"id": "pctv", "label": "Percentage", "type": "number", "def": "25", "min": 0, "max": 1000, "showIf": {"mode": ["pct"]}}, {"id": "faces", "label": "Clock faces", "type": "select", "def": "no", "cls": "mc-ghost", "options": [["no", "Hide clock faces"], ["yes", "Show clock faces"]]}], example: {"mode": "between", "h1": 14, "m1": 45, "h2": 17, "m2": 20}, run: (function (v, H) {
      function two(x) { return (String(x).length < 2 ? '0' : '') + x; }
      function clock(h, m) { return two(h) + ':' + two(m); }
      /* number line for the answer: segs are [fromMin, toMin, label, kind]
         with kind b (bridge, teal), s (stride, purple), f (finish, green) */
      function timeline(segs, title) {
        if (!segs.length) return '';
        function clk(t) { return two(Math.floor(t / 60) % 24) + ':' + two(t % 60); }
        var span = segs[segs.length - 1][1] - segs[0][0];
        if (span <= 0) return '';
        var shares = [], tot = 0, i;
        for (i = 0; i < segs.length; i++) { var sh = Math.max((segs[i][1] - segs[i][0]) / span, 0.18); shares.push(sh); tot += sh; }
        var x = 40, xs = [40];
        for (i = 0; i < segs.length; i++) { x += shares[i] / tot * 640; xs.push(x); }
        var INKS = { b: '#2F6886', s: '#6B46C1', f: '#2F855A' };
        var svg = '<line x1="30" y1="112" x2="690" y2="112" stroke="#B8CCD8" stroke-width="2.5" stroke-linecap="round"/>';
        for (i = 0; i < xs.length; i++) {
          var tick = i === 0 ? '#2F6886' : (i === xs.length - 1 ? '#B4531F' : '#55677A');
          svg += '<line x1="' + xs[i].toFixed(1) + '" y1="102" x2="' + xs[i].toFixed(1) + '" y2="122" stroke="' + tick + '" stroke-width="2.5" stroke-linecap="round"/>'
            + '<text x="' + xs[i].toFixed(1) + '" y="143" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15.5" font-weight="800" fill="' + tick + '">' + clk(i === 0 ? segs[0][0] : segs[i - 1][1]) + '</text>';
        }
        for (i = 0; i < segs.length; i++) {
          var x1 = xs[i], x2 = xs[i + 1], mid = (x1 + x2) / 2;
          var arcH = Math.min(64, 26 + (x2 - x1) * 0.12);
          var ink = INKS[segs[i][3]];
          svg += '<path d="M ' + x1.toFixed(1) + ' 100 Q ' + mid.toFixed(1) + ' ' + (100 - arcH).toFixed(1) + ' ' + x2.toFixed(1) + ' 100" fill="none" stroke="' + ink + '" stroke-width="3" stroke-linecap="round"/>'
            + '<text x="' + mid.toFixed(1) + '" y="' + (100 - arcH / 2 - 10).toFixed(1) + '" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15" font-weight="700" fill="' + ink + '">' + segs[i][2] + '</text>';
        }
        return '<div class="mc-tl"><p class="mc-tl-h">' + title + '</p>'
          + '<svg viewBox="0 0 720 152" role="img" aria-label="Number line showing each hop in the working">' + svg + '</svg></div>';
      }
      /* Durations can land on a fraction of a minute once a multiplier or a
         percentage is involved (25% of 1 h 30 is 22.5 min), so the formatter
         works in whole seconds rather than rounding minutes and lying. */
      function durTxt(mins) {
        var totSec = Math.round(Math.abs(mins) * 60);
        var hh = Math.floor(totSec / 3600), mm = Math.floor((totSec % 3600) / 60), ss = totSec % 60;
        var bits = [];
        if (hh > 0) bits.push(H.fmt(hh) + ' ' + H.plural(hh, 'hour', 'hours'));
        if (mm > 0) bits.push(H.fmt(mm) + ' ' + H.plural(mm, 'minute', 'minutes'));
        if (ss > 0) bits.push(H.fmt(ss) + ' ' + H.plural(ss, 'second', 'seconds'));
        if (!bits.length) bits.push('0 minutes');
        return (mins < 0 ? '−' : '') + bits.join(' ');
      }
      var FONT = 'Lexend, Inter, sans-serif';
      /* n equal blocks, total bracketed underneath. Only drawn for a small
         whole number of copies: 100 slivers teach nobody anything. */
      function mulBar(n, dtxt, ttxt) {
        if (!(n >= 1 && n <= 12 && Math.floor(n) === n)) return '';
        var x0 = 30, W = 660, cw = W / n, i, svg = '';
        for (i = 0; i < n; i++) {
          var x = x0 + i * cw;
          svg += '<rect x="' + x.toFixed(1) + '" y="26" width="' + (cw - 5).toFixed(1) + '" height="46" rx="7" fill="' + (i % 2 ? '#DCE9F1' : '#C4DCEA') + '" stroke="#2F6886" stroke-width="2"/>'
            + '<text x="' + (x + (cw - 5) / 2).toFixed(1) + '" y="55" text-anchor="middle" font-family="' + FONT + '" font-size="' + (n > 8 ? 11 : 14) + '" font-weight="700" fill="#23485C">' + dtxt + '</text>';
        }
        svg += '<line x1="' + x0 + '" y1="84" x2="' + (x0 + W - 5) + '" y2="84" stroke="#B4531F" stroke-width="2.5" stroke-linecap="round"/>'
          + '<text x="' + (x0 + (W - 5) / 2) + '" y="108" text-anchor="middle" font-family="' + FONT + '" font-size="16" font-weight="800" fill="#B4531F">' + ttxt + '</text>';
        return '<div class="mc-tl"><p class="mc-tl-h">' + H.fmt(n) + ' Equal Blocks</p>'
          + '<svg viewBox="0 0 720 120" role="img" aria-label="Bar model showing the duration repeated">' + svg + '</svg></div>';
      }
      /* the whole time as one bar with the slice shaded */
      function pctBar(pc, dtxt, atxt) {
        if (!(pc > 0 && pc <= 100)) return '';
        var x0 = 30, W = 660, w = W * pc / 100;
        var tx = Math.min(Math.max(x0 + w / 2, x0 + 46), x0 + W - 46);
        var svg = '<rect x="' + x0 + '" y="34" width="' + W + '" height="46" rx="7" fill="#EDF3F7" stroke="#2F6886" stroke-width="2"/>'
          + '<rect x="' + x0 + '" y="34" width="' + w.toFixed(1) + '" height="46" rx="7" fill="#C4DCEA" stroke="#2F6886" stroke-width="2"/>'
          + '<text x="' + (x0 + W / 2) + '" y="22" text-anchor="middle" font-family="' + FONT + '" font-size="14" font-weight="700" fill="#55677A">' + dtxt + '</text>'
          + '<text x="' + tx.toFixed(1) + '" y="63" text-anchor="middle" font-family="' + FONT + '" font-size="14" font-weight="800" fill="#23485C">' + H.fmt(pc) + '%</text>'
          + '<text x="' + tx.toFixed(1) + '" y="104" text-anchor="middle" font-family="' + FONT + '" font-size="16" font-weight="800" fill="#B4531F">' + atxt + '</text>';
        return '<div class="mc-tl"><p class="mc-tl-h">The Whole Time, With the Slice Shaded</p>'
          + '<svg viewBox="0 0 720 116" role="img" aria-label="Bar model showing the percentage slice of the time">' + svg + '</svg></div>';
      }
      var steps = [];
      var segs = [];
      if (v.mode === 'between') {
        var start = v.h1 * 60 + v.m1;
        var end = v.h2 * 60 + v.m2;
        var nextDay = end <= start && !(end === start);
        if (end < start) end += 24 * 60;
        if (end === start) throw new Error('Those are the same time. The gap is 0 minutes.');
        var total = end - start;
        var toHour = (60 - v.m1) % 60;
        var cursor = start + toHour;
        if (toHour > 0 && cursor <= end) {
          steps.push('Bridge to the next whole hour: ' + clock(v.h1, v.m1) + ' to ' + clock(Math.floor(cursor / 60) % 24, 0) + ' is ' + H.fmt(toHour) + ' minutes');
          segs.push([start, cursor, '+' + H.fmt(toHour) + ' min', 'b']);
        } else {
          cursor = start;
        }
        var wholeHours = Math.floor((end - cursor) / 60);
        if (wholeHours > 0) {
          steps.push('Stride the whole hours: ' + clock(Math.floor(cursor / 60) % 24, cursor % 60) + ' to ' + clock(Math.floor((cursor + wholeHours * 60) / 60) % 24, cursor % 60) + ' is ' + H.fmt(wholeHours) + ' ' + H.plural(wholeHours, 'hour', 'hours'));
          segs.push([cursor, cursor + wholeHours * 60, '+' + H.fmt(wholeHours) + ' ' + H.plural(wholeHours, 'hour', 'hours'), 's']);
          cursor += wholeHours * 60;
        }
        var lastBit = end - cursor;
        if (lastBit > 0) {
          steps.push('Finish the minutes: ' + clock(Math.floor(cursor / 60) % 24, cursor % 60) + ' to ' + clock(v.h2, v.m2) + ' is ' + H.fmt(lastBit) + ' minutes');
          segs.push([cursor, end, '+' + H.fmt(lastBit) + ' min', 'f']);
        }
        var hh = Math.floor(total / 60), mm = total % 60;
        var ans = (hh > 0 ? H.fmt(hh) + ' ' + H.plural(hh, 'hour', 'hours') + (mm > 0 ? ' ' : '') : '') + (mm > 0 || hh === 0 ? H.fmt(mm) + ' minutes' : '');
        steps.push('Add the pieces: the total is ' + ans);
        var out = { answer: ans, steps: steps, visual: timeline(segs, 'The Bridging Method') };
        if (nextDay) out.note = 'The end time is earlier on the clock than the start, so this assumes it is the NEXT day (an overnight gap).';
        else out.note = 'As a decimal for speed calculations, ' + H.fmt(mm) + ' minutes is ' + H.fmt(mm / 60) + ' of an hour, so ' + H.fmt(total / 60) + ' hours.';
        return out;
      }
      /* Multiply and percentage both run the same three-move method schools
         teach: into minutes, do the sum, back into hours and minutes. Added
         2026-08-26 off the search data, which showed steady demand for
         "1 hour 45 times 2" and "25% of 2 hours" that the page could not
         answer. */
      if (v.mode === 'mul') {
        var totM = v.h1 * 60 + v.m1;
        if (totM <= 0) throw new Error('Enter a duration to multiply, not zero hours and zero minutes.');
        var resM = totM * v.mult;
        steps.push(v.h1 > 0
          ? 'Change the duration into minutes: ' + H.fmt(v.h1) + ' × 60 + ' + H.fmt(v.m1) + ' = ' + H.fmt(totM) + ' minutes'
          : 'The duration is already in minutes: ' + H.fmt(totM) + ' minutes');
        steps.push('Multiply the minutes: ' + H.fmt(totM) + ' × ' + H.fmt(v.mult) + ' = ' + H.fmt(resM) + ' minutes');
        var ansM = durTxt(resM);
        steps.push('Change back into hours and minutes: ' + H.fmt(resM) + ' minutes = ' + ansM);
        return {
          answer: ansM,
          steps: steps,
          visual: mulBar(v.mult, H.fmt(v.h1) + ' h ' + H.fmt(v.m1) + ' m', ansM),
          note: 'Never multiply a time as if it were one decimal number. 1 hour 45 minutes doubled is 3 hours 30 minutes, but 1.45 × 2 is 2.9, which is not a time at all.'
        };
      }
      if (v.mode === 'pct') {
        var totP = v.h1 * 60 + v.m1;
        if (totP <= 0) throw new Error('Enter a time first, not zero hours and zero minutes.');
        var amt = totP * v.pctv / 100;
        steps.push(v.h1 > 0
          ? 'Change the time into minutes: ' + H.fmt(v.h1) + ' × 60 + ' + H.fmt(v.m1) + ' = ' + H.fmt(totP) + ' minutes'
          : 'The time is already in minutes: ' + H.fmt(totP) + ' minutes');
        steps.push('Take the percentage: ' + H.fmt(totP) + ' × ' + H.fmt(v.pctv) + ' ÷ 100 = ' + H.fmt(amt) + ' minutes');
        var ansP = durTxt(amt);
        steps.push('Change back into hours and minutes: ' + H.fmt(amt) + ' minutes = ' + ansP);
        return {
          answer: ansP,
          steps: steps,
          visual: pctBar(v.pctv, durTxt(totP) + ' altogether', ansP),
          note: 'Added on top, ' + durTxt(totP) + ' plus ' + H.fmt(v.pctv) + '% is ' + durTxt(totP + amt) + '. That is the sum behind extra time in an exam: a paper of ' + durTxt(totP) + ' with ' + H.fmt(v.pctv) + '% extra time runs for ' + durTxt(totP + amt) + '.'
        };
      }
      var startA = v.h1 * 60 + v.m1;
      var endA = startA + v.h2 * 60 + v.m2;
      var dayWrap = endA >= 24 * 60;
      var endMod = endA % (24 * 60);
      if (v.h2 > 0) {
        steps.push('Add the whole hours first: ' + clock(v.h1, v.m1) + ' + ' + H.fmt(v.h2) + ' ' + H.plural(v.h2, 'hour', 'hours') + ' = ' + clock(Math.floor((startA + v.h2 * 60) / 60) % 24, v.m1));
        segs.push([startA, startA + v.h2 * 60, '+' + H.fmt(v.h2) + ' ' + H.plural(v.h2, 'hour', 'hours'), 's']);
      }
      if (v.m2 > 0) {
        steps.push('Then the minutes: + ' + H.fmt(v.m2) + ' minutes lands on ' + clock(Math.floor(endMod / 60), endMod % 60));
        segs.push([startA + v.h2 * 60, endA, '+' + H.fmt(v.m2) + ' min', 'f']);
      }
      steps.push('The finishing time is ' + clock(Math.floor(endMod / 60), endMod % 60));
      var out2 = { answer: clock(Math.floor(endMod / 60), endMod % 60), steps: steps, visual: timeline(segs, 'Add the Hours, Then the Minutes') };
      if (dayWrap) out2.note = 'That crosses midnight into the next day.';
      return out2;
    }), preview: (function (v, H) {
      function two(x) { return (String(x).length < 2 ? '0' : '') + x; }
      if (v.mode === 'between') return 'From ' + two(v.h1) + ':' + two(v.m1) + ' to ' + two(v.h2) + ':' + two(v.m2);
      function dur(h, m) { return (String(h) === '0' ? '' : h + ' h ') + m + ' min'; }
      if (v.mode === 'mul') return dur(v.h1, v.m1) + '  ×  ' + v.mult;
      if (v.mode === 'pct') return v.pctv + '% of ' + dur(v.h1, v.m1);
      return two(v.h1) + ':' + two(v.m1) + '  +  ' + v.h2 + ' h ' + v.m2 + ' min';
    }), widget: (function (v, H) {
      function two(x) { return (String(x).length < 2 ? '0' : '') + x; }
      var isAdd = v.mode === 'add';
      /* Clock faces only mean anything when the answer IS a clock time, so the
         faces tab disappears in the two duration modes rather than sitting
         there dead (2026-08-26). */
      var clockMode = v.mode === 'between' || v.mode === 'add';
      var on = v.faces === 'yes' && clockMode;
      var TABS = [['between', 'Time between two times'], ['add', 'Add a duration to a time'], ['mul', 'Multiply a duration'], ['pct', 'Percentage of a time']];
      var tabs = '', ti;
      for (ti = 0; ti < TABS.length; ti++) {
        tabs += '<button type="button" class="mc-rule-tab' + (v.mode === TABS[ti][0] ? ' is-on' : '') + '" data-mc-tap data-set="mode:' + TABS[ti][0] + '">' + TABS[ti][1] + '</button>';
      }
      var html = '<div class="mc-wrow"><div class="mc-rule-tabs">' + tabs + '</div><span class="mc-wspace"></span>'
        + (clockMode ? '<button type="button" class="mc-rule-tab mc-tab-faces' + (on ? ' is-on' : '') + '" data-mc-tap data-set="faces:' + (on ? 'no' : 'yes') + '">'
          + (on ? 'Hide clock faces' : 'Show clock faces') + '</button>' : '')
        + '</div>';
      if (!on) return html;
      var h1 = Number(v.h1), m1 = Number(v.m1), h2 = Number(v.h2), m2 = Number(v.m2);
      if (!isFinite(h1) || !isFinite(m1) || !isFinite(h2) || !isFinite(m2)) return html;
      if (h1 < 0 || h1 > 23 || m1 < 0 || m1 > 59 || h2 < 0 || m2 < 0 || m2 > 59) return html;
      function face(h, m, hue, lbl) {
        var hd = ((h % 12) + m / 60) * 30 - 90;
        var md = m * 6 - 90;
        function px(a, r) { return (60 + r * Math.cos(a * Math.PI / 180)).toFixed(1); }
        function py(a, r) { return (60 + r * Math.sin(a * Math.PI / 180)).toFixed(1); }
        var ticks = '', i, a;
        for (i = 0; i < 12; i++) {
          a = i * 30;
          ticks += '<line x1="' + px(a, 46) + '" y1="' + py(a, 46) + '" x2="' + px(a, 50) + '" y2="' + py(a, 50) + '" stroke="currentColor" stroke-width="' + (i % 3 === 0 ? 3 : 1.6) + '" stroke-linecap="round" opacity=".55"/>';
        }
        return '<div class="mc-clockcard mc-clock-' + hue + '"><svg class="mc-clockface" viewBox="0 0 120 120" aria-hidden="true">'
          + '<circle cx="60" cy="60" r="54" fill="#fff" stroke="currentColor" stroke-width="3"/>' + ticks
          + '<line x1="60" y1="60" x2="' + px(hd, 26) + '" y2="' + py(hd, 26) + '" stroke="currentColor" stroke-width="4.5" stroke-linecap="round"/>'
          + '<line x1="60" y1="60" x2="' + px(md, 38) + '" y2="' + py(md, 38) + '" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".8"/>'
          + '<circle cx="60" cy="60" r="4" fill="currentColor"/></svg>'
          + '<span class="mc-clock-lbl">' + lbl + '</span><span class="mc-clock-time">' + two(h) + ':' + two(m) + '</span></div>';
      }
      var startMin = h1 * 60 + m1, endMin, gapMin, chip;
      if (isAdd) {
        if (h2 > 99) return html;
        endMin = (startMin + h2 * 60 + m2) % 1440;
        chip = '+ ' + H.fmt(h2) + ' h ' + H.fmt(m2) + ' min';
      } else {
        if (h2 > 23) return html;
        endMin = h2 * 60 + m2;
        gapMin = endMin - startMin;
        if (gapMin < 0) gapMin += 1440;
        var gh = Math.floor(gapMin / 60), gm = gapMin % 60;
        chip = (gh > 0 ? H.fmt(gh) + ' ' + H.plural(gh, 'hour', 'hours') + (gm > 0 ? ' ' : '') : '') + (gm > 0 || gh === 0 ? H.fmt(gm) + ' min' : '');
      }
      return html + '<div class="mc-clockrow">'
        + face(h1, m1, '1', 'Start')
        + '<div class="mc-clock-mid"><span class="mc-clock-gap">' + chip + '</span><span class="mc-clock-arr" aria-hidden="true">→</span></div>'
        + face(Math.floor(endMin / 60), endMin % 60, '2', 'End')
        + '</div>';
    }), labels: (function (v, H) {
      if (v.mode === 'add') return { h1: 'Hour', m1: 'Minutes', h2: 'Hours', m2: 'Minutes', 'cap:b': 'Duration to add' };
      if (v.mode === 'mul') return { h1: 'Hours', m1: 'Minutes', 'cap:a': 'Duration' };
      if (v.mode === 'pct') return { h1: 'Hours', m1: 'Minutes', 'cap:a': 'The whole time' };
      return { h1: 'Hour', m1: 'Minutes', h2: 'Hour', m2: 'Minutes', 'cap:b': 'End time' };
    }) };
MC_CONFIG["written-methods-calculator"] = { name: "Written Methods Calculator", fields: [{"id": "mode", "label": "Method", "type": "select", "def": "multiply", "options": [["multiply", "Long multiplication"], ["divide", "Bus stop division"]]}, {"id": "a", "label": "First number (the big one)", "type": "number", "def": "347", "gt": 0, "int": true, "max": 99999}, {"id": "b", "label": "Multiply or divide by", "type": "number", "def": "26", "gt": 0, "int": true, "max": 999}], example: {"mode": "multiply", "a": 347, "b": 26}, run: (function (v, H) {
      var steps = [];
      if (v.mode === 'multiply') {
        var digits = String(v.b).split('').reverse();
        var partials = [];
        for (var i = 0; i < digits.length; i++) {
          var dv = Number(digits[i]) * Math.pow(10, i);
          if (dv === 0) continue;
          var part = v.a * dv;
          partials.push(part);
          steps.push('Multiply by the ' + (i === 0 ? 'units' : i === 1 ? 'tens' : i === 2 ? 'hundreds' : 'thousands') + ': ' + H.fmt(v.a) + ' × ' + H.fmt(dv) + ' = ' + H.fmt(part));
        }
        var total = v.a * v.b;
        if (partials.length > 1) {
          steps.push('Add the partial products: ' + partials.map(H.fmt).join(' + ') + ' = ' + H.fmt(total));
        } else {
          steps.push('Only one partial product, so that is the answer: ' + H.fmt(total));
        }
        return {
          answer: H.fmt(total), steps: steps,
          note: 'Estimate check: ' + H.fmt(v.a) + ' is near ' + H.fmt(Math.round(v.a / Math.pow(10, String(v.a).length - 1)) * Math.pow(10, String(v.a).length - 1)) + ', so an answer wildly far from that times ' + H.fmt(v.b) + ' would be a red flag.'
        };
      }
      if (v.b > 99) throw new Error('For bus stop division keep the divisor to 2 digits at most.');
      var ds = String(v.a).split('');
      var carry = 0, quotientDigits = [];
      for (var j = 0; j < ds.length; j++) {
        var current = carry * 10 + Number(ds[j]);
        var qd = Math.floor(current / v.b);
        var rem = current % v.b;
        if (j === 0) {
          steps.push('Start at the left: ' + H.fmt(v.b) + ' into ' + H.fmt(current) + ' goes ' + H.fmt(qd) + (rem ? ' remainder ' + H.fmt(rem) : ' exactly'));
        } else {
          steps.push('Bring down the ' + ds[j] + ' to make ' + H.fmt(current) + ': ' + H.fmt(v.b) + ' into ' + H.fmt(current) + ' goes ' + H.fmt(qd) + (rem ? ' remainder ' + H.fmt(rem) : ' exactly'));
        }
        quotientDigits.push(qd);
        carry = rem;
      }
      var quotient = Math.floor(v.a / v.b);
      var remainder = v.a % v.b;
      var ansD = H.fmt(quotient) + (remainder ? ' remainder ' + H.fmt(remainder) : '');
      steps.push('Read the answer off the top of the bus stop: ' + ansD);
      return {
        answer: ansD, steps: steps,
        note: 'Check: ' + H.fmt(quotient) + ' × ' + H.fmt(v.b) + (remainder ? ' + ' + H.fmt(remainder) : '') + ' = ' + H.fmt(quotient * v.b + remainder) + ', back to the number you started with.'
      };
    }), preview: (function (v, H) { return v.a + (v.mode === 'multiply' ? ' × ' : ' ÷ ') + v.b; }) };
MC_CONFIG["add-fractions-calculator"] = { name: "Adding Fractions Calculator", fields: [{"id": "w1", "group": "A", "groupLabel": "First fraction", "slot": "whole", "label": "First whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "a", "group": "A", "slot": "num", "label": "First numerator (top)", "type": "number", "def": "1", "int": true}, {"id": "b", "group": "A", "slot": "den", "label": "First denominator (bottom)", "type": "number", "def": "3", "gt": 0, "int": true}, {"id": "sym", "slot": "op", "type": "static", "text": "+", "label": "Operation"}, {"id": "w2", "group": "B", "groupLabel": "Second fraction", "slot": "whole", "label": "Second whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "c", "group": "B", "slot": "num", "label": "Second numerator (top)", "type": "number", "def": "1", "int": true}, {"id": "d", "group": "B", "slot": "den", "label": "Second denominator (bottom)", "type": "number", "def": "6", "gt": 0, "int": true}], example: {"w1": 0, "a": 1, "b": 3, "w2": 0, "c": 1, "d": 6}, run: (function (v, H) {
      var steps = [];
      var b = Math.abs(v.b), d = Math.abs(v.d);
      var a = H.toImproper(v.w1, v.a, b);
      var c = H.toImproper(v.w2, v.c, d);
      if (v.w1 !== 0) steps.push('Turn the first mixed number into an improper fraction: ' + H.fmt(Math.abs(v.w1)) + ' × ' + H.fmt(b) + ' + ' + H.fmt(Math.abs(v.a)) + ' = ' + H.fmt(Math.abs(a)) + ', so it is ' + H.fracStr(a, b));
      if (v.w2 !== 0) steps.push('Same for the second: ' + H.fmt(Math.abs(v.w2)) + ' × ' + H.fmt(d) + ' + ' + H.fmt(Math.abs(v.c)) + ' = ' + H.fmt(Math.abs(c)) + ', so it is ' + H.fracStr(c, d));
      var l = H.lcm(b, d), f1 = l / b, f2 = l / d;
      var na = a * f1, nc = c * f2;
      if (b === d) steps.push('The denominators already match at ' + H.fmt(b) + ', so nothing needs rewriting');
      else {
        steps.push('The bottoms are different, so find the lowest common denominator of ' + H.fmt(b) + ' and ' + H.fmt(d) + ': it is ' + H.fmt(l));
        steps.push('Rewrite both over ' + H.fmt(l) + ': ' + H.fracStr(a, b) + ' = ' + H.fracStr(na, l) + ' and ' + H.fracStr(c, d) + ' = ' + H.fracStr(nc, l));
      }
      var n = na + nc, dd = l;
      steps.push('Add the tops, keep the bottom: ' + H.fmt(na) + ' + ' + H.fmt(nc) + ' = ' + H.fmt(n) + ', giving ' + H.fracStr(n, dd));
      if (dd < 0) { n = -n; dd = -dd; }
      var g = H.gcd(n, dd) || 1;
      var sn = n / g, sd = dd / g;
      if (g > 1) steps.push('Simplify: the highest common factor of ' + H.fmt(Math.abs(n)) + ' and ' + H.fmt(dd) + ' is ' + H.fmt(g) + ', so divide top and bottom by it to get ' + H.fracStr(sn, sd));
      var ans = H.mixedStr(sn, sd);
      if (Math.abs(sn) > sd && sd !== 1) steps.push(H.fracStr(sn, sd) + ' is top-heavy: ' + H.fmt(sd) + ' goes into ' + H.fmt(Math.abs(sn)) + ' ' + H.fmt(Math.floor(Math.abs(sn) / sd)) + ' times with ' + H.fmt(Math.abs(sn) % sd) + ' left over, so it is ' + ans);
      else if (g === 1) steps.push(ans + ' is already in its simplest form');
      /* one hop on a number line cut into the common denominator: only for
         simple positive sums that fit inside two whole ones */
      var visual = '';
      if (na >= 0 && nc > 0 && l <= 24 && n / l <= 2) {
        var K = Math.max(1, Math.ceil(n / l));
        function X(t) { return (40 + t / K * 640).toFixed(1); }
        var svg = '<line x1="30" y1="112" x2="690" y2="112" stroke="#B8CCD8" stroke-width="2.5" stroke-linecap="round"/>';
        var lblXs = [Number(X(na / l)), Number(X(n / l))];
        for (var i = 0; i <= K * l; i++) {
          var whole = i % l === 0;
          var xt = X(i / l);
          svg += '<line x1="' + xt + '" y1="' + (whole ? 102 : 107) + '" x2="' + xt + '" y2="' + (whole ? 122 : 117) + '" stroke="' + (whole ? '#93A8B8' : '#D3E0E8') + '" stroke-width="' + (whole ? 2.5 : 1.4) + '"/>';
          if (whole && Math.min(Math.abs(Number(xt) - lblXs[0]), Math.abs(Number(xt) - lblXs[1])) > 34) {
            svg += '<text x="' + xt + '" y="143" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15.5" font-weight="800" fill="#93A8B8">' + (i / l) + '</text>';
          }
        }
        function mark(num, ink) {
          return '<circle cx="' + X(num / l) + '" cy="112" r="5" fill="' + ink + '"/>'
            + '<text x="' + X(num / l) + '" y="143" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15.5" font-weight="800" fill="' + ink + '">' + (num === 0 ? '0' : (num % l === 0 ? H.fmt(num / l) : H.fmt(num) + '/' + H.fmt(l))) + '</text>';
        }
        svg += mark(na, '#2F6886') + mark(n, '#B4531F');
        var x1 = Number(X(na / l)), x2 = Number(X(n / l)), mid = (x1 + x2) / 2;
        var arcH = Math.min(64, 26 + Math.abs(x2 - x1) * 0.12);
        svg += '<path d="M ' + x1 + ' 100 Q ' + mid.toFixed(1) + ' ' + (100 - arcH).toFixed(1) + ' ' + x2 + ' 100" fill="none" stroke="#2F855A" stroke-width="3" stroke-linecap="round"/>'
          + '<path d="M ' + x2 + ' 100 l -3 -9 m 3 9 l -10 -2" stroke="#2F855A" stroke-width="2.5" fill="none" stroke-linecap="round"/>'
          + '<text x="' + mid.toFixed(1) + '" y="' + (100 - arcH / 2 - 10).toFixed(1) + '" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15" font-weight="700" fill="#2F855A">+' + H.fmt(nc) + '/' + H.fmt(l) + '</text>';
        visual = '<div class="mc-tl"><p class="mc-tl-h">On the Number Line</p>'
          + '<svg viewBox="0 0 720 152" role="img" aria-label="Number line showing the hop">' + svg + '</svg></div>';
      }
      return { answer: ans, steps: steps, visual: visual };
    }), preview: (function (v, H) {
      function one(w, n, d) {
        var ws = (w === '?' || Number(w) === 0) ? '' : w + ' ';
        return ws + H.frTok(n, d);
      }
      return one(v.w1, v.a, v.b) + '  +  ' + one(v.w2, v.c, v.d);
    }), widget: (function (v, H) {
      var w1 = Number(v.w1), a = Number(v.a), b = Number(v.b), w2 = Number(v.w2), c = Number(v.c), d = Number(v.d);
      var have = isFinite(w1) && isFinite(a) && isFinite(b) && isFinite(w2) && isFinite(c) && isFinite(d) && b > 0 && d > 0;
      if (!have) return '';
      var A = H.toImproper(w1, a, b), C = H.toImproper(w2, c, d);
      var L = b / H.gcd(b, d) * d;
      var n1 = A * (L / b), n2 = C * (L / d);
      var sum = n1 + n2;
      var mk = H.mkHtml;
      function fr(n, dd) { return mk(H.fracStr(n, dd)); }
      var gS = H.gcd(sum, L);
      var fin = H.mixedStr(sum / gS, L / gS);
      var seq = fr(n1, L) + ' + ' + fr(n2, L) + ' = ';
      seq += fin === H.fracStr(sum, L) ? '<b>' + fr(sum, L) + '</b>' : fr(sum, L) + ' = <b>' + mk(fin) + '</b>';
      var pre = [];
      if (L !== b) pre.push(fr(A, b) + ' = ' + fr(n1, L));
      if (L !== d) pre.push(fr(C, d) + ' = ' + fr(n2, L));
      var barLine = '<p class="mc-rule-line"><span class="mc-rule-f">' + (pre.length ? pre.join(' and ') + ', so ' : '') + seq + '</span>' +
        '<span class="mc-rule-why">Only the bottoms need matching, then the tops add.</span></p>';
      var drawable = w1 === 0 && w2 === 0 && a >= 0 && c >= 0 && a <= b && c <= d && b <= 12 && d <= 12 && L <= 24 &&
        Number.isInteger(a) && Number.isInteger(c) && Number.isInteger(b) && Number.isInteger(d) && (a > 0 || c > 0);
      if (!drawable) return barLine;
      var recut = b !== d;
      var y = 0, rows = '';
      function row(label, cells1, f1a, f1b, lbl1, cells2, f2a, f2b, lbl2) {
        var out = '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">' + label + '</text>';
        out += H.fbBar(60, y + 20, 190, cells1, f1a, f1b) + H.fbFrac(280, y + 36, lbl1[0], lbl1[1]);
        if (cells2) {
          out += '<text class="mc-fb-op" x="316" y="' + (y + 45) + '">+</text>';
          out += H.fbBar(340, y + 20, 190, cells2, f2a, f2b) + H.fbFrac(560, y + 36, lbl2[0], lbl2[1]);
        }
        y += 80;
        return out;
      }
      rows += row('Your fractions', b, a, 0, [a, b], d, 0, c, [c, d]);
      if (recut) rows += row('Cut both into ' + H.fmt(L) + 'ths, the common denominator', L, n1, 0, [n1, L], L, 0, n2, [n2, L]);
      if (sum <= L) {
        rows += row('Together', L, n1, n2, [sum, L], 0, 0, 0, null);
      } else {
        var t1 = Math.min(n1, L), o1 = Math.min(L - t1, n2);
        var out2 = '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">Together, more than one whole</text>';
        out2 += H.fbBar(60, y + 20, 190, L, t1, o1) + H.fbBar(266, y + 20, 190, L, n1 - t1, n2 - o1) + H.fbFrac(486, y + 36, sum, L);
        y += 80;
        rows += out2;
      }
      return '<p class="mc-tri-hint">Watch the bars: both fractions get cut into the same size pieces, then the pieces just add up.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 ' + (y - 14) + '" style="max-width:640px" role="group" aria-label="Bar model of the fraction addition">' + rows + '</svg>' +
        barLine;
    }) };
MC_CONFIG["subtract-fractions-calculator"] = { name: "Subtracting Fractions Calculator", fields: [{"id": "w1", "group": "A", "groupLabel": "First fraction", "slot": "whole", "label": "First whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "a", "group": "A", "slot": "num", "label": "First numerator (top)", "type": "number", "def": "3", "int": true}, {"id": "b", "group": "A", "slot": "den", "label": "First denominator (bottom)", "type": "number", "def": "4", "gt": 0, "int": true}, {"id": "sym", "slot": "op", "type": "static", "text": "\u2212", "label": "Operation"}, {"id": "w2", "group": "B", "groupLabel": "Second fraction", "slot": "whole", "label": "Second whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "c", "group": "B", "slot": "num", "label": "Second numerator (top)", "type": "number", "def": "1", "int": true}, {"id": "d", "group": "B", "slot": "den", "label": "Second denominator (bottom)", "type": "number", "def": "3", "gt": 0, "int": true}], example: {"w1": 0, "a": 3, "b": 4, "w2": 0, "c": 1, "d": 3}, run: (function (v, H) {
      var steps = [];
      var b = Math.abs(v.b), d = Math.abs(v.d);
      var a = H.toImproper(v.w1, v.a, b);
      var c = H.toImproper(v.w2, v.c, d);
      if (v.w1 !== 0) steps.push('Turn the first mixed number into an improper fraction: ' + H.fmt(Math.abs(v.w1)) + ' × ' + H.fmt(b) + ' + ' + H.fmt(Math.abs(v.a)) + ' = ' + H.fmt(Math.abs(a)) + ', so it is ' + H.fracStr(a, b));
      if (v.w2 !== 0) steps.push('Same for the second: ' + H.fmt(Math.abs(v.w2)) + ' × ' + H.fmt(d) + ' + ' + H.fmt(Math.abs(v.c)) + ' = ' + H.fmt(Math.abs(c)) + ', so it is ' + H.fracStr(c, d));
      var l = H.lcm(b, d), f1 = l / b, f2 = l / d;
      var na = a * f1, nc = c * f2;
      if (b === d) steps.push('The denominators already match at ' + H.fmt(b) + ', so nothing needs rewriting');
      else {
        steps.push('The bottoms are different, so find the lowest common denominator of ' + H.fmt(b) + ' and ' + H.fmt(d) + ': it is ' + H.fmt(l));
        steps.push('Rewrite both over ' + H.fmt(l) + ': ' + H.fracStr(a, b) + ' = ' + H.fracStr(na, l) + ' and ' + H.fracStr(c, d) + ' = ' + H.fracStr(nc, l));
      }
      var n = na - nc, dd = l;
      steps.push('Take the second top from the first, keep the bottom: ' + H.fmt(na) + ' − ' + H.fmt(nc) + ' = ' + H.fmt(n) + ', giving ' + H.fracStr(n, dd));
      if (dd < 0) { n = -n; dd = -dd; }
      var g = H.gcd(n, dd) || 1;
      var sn = n / g, sd = dd / g;
      if (g > 1) steps.push('Simplify: the highest common factor of ' + H.fmt(Math.abs(n)) + ' and ' + H.fmt(dd) + ' is ' + H.fmt(g) + ', so divide top and bottom by it to get ' + H.fracStr(sn, sd));
      var ans = H.mixedStr(sn, sd);
      if (Math.abs(sn) > sd && sd !== 1) steps.push(H.fracStr(sn, sd) + ' is top-heavy: ' + H.fmt(sd) + ' goes into ' + H.fmt(Math.abs(sn)) + ' ' + H.fmt(Math.floor(Math.abs(sn) / sd)) + ' times with ' + H.fmt(Math.abs(sn) % sd) + ' left over, so it is ' + ans);
      else if (g === 1) steps.push(ans + ' is already in its simplest form');
      /* one hop LEFT on a number line cut into the common denominator: only
         for simple positive takes that start inside two whole ones */
      var visual = '';
      if (n >= 0 && nc > 0 && l <= 24 && na / l <= 2) {
        var K = Math.max(1, Math.ceil(na / l));
        function X(t) { return (40 + t / K * 640).toFixed(1); }
        var svg = '<line x1="30" y1="112" x2="690" y2="112" stroke="#B8CCD8" stroke-width="2.5" stroke-linecap="round"/>';
        var lblXs = [Number(X(na / l)), Number(X(n / l))];
        for (var i = 0; i <= K * l; i++) {
          var whole = i % l === 0;
          var xt = X(i / l);
          svg += '<line x1="' + xt + '" y1="' + (whole ? 102 : 107) + '" x2="' + xt + '" y2="' + (whole ? 122 : 117) + '" stroke="' + (whole ? '#93A8B8' : '#D3E0E8') + '" stroke-width="' + (whole ? 2.5 : 1.4) + '"/>';
          if (whole && Math.min(Math.abs(Number(xt) - lblXs[0]), Math.abs(Number(xt) - lblXs[1])) > 34) {
            svg += '<text x="' + xt + '" y="143" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15.5" font-weight="800" fill="#93A8B8">' + (i / l) + '</text>';
          }
        }
        function mark(num, ink) {
          return '<circle cx="' + X(num / l) + '" cy="112" r="5" fill="' + ink + '"/>'
            + '<text x="' + X(num / l) + '" y="143" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15.5" font-weight="800" fill="' + ink + '">' + (num === 0 ? '0' : (num % l === 0 ? H.fmt(num / l) : H.fmt(num) + '/' + H.fmt(l))) + '</text>';
        }
        svg += mark(na, '#2F6886') + mark(n, '#B4531F');
        var x1 = Number(X(na / l)), x2 = Number(X(n / l)), mid = (x1 + x2) / 2;
        var arcH = Math.min(64, 26 + Math.abs(x2 - x1) * 0.12);
        svg += '<path d="M ' + x1 + ' 100 Q ' + mid.toFixed(1) + ' ' + (100 - arcH).toFixed(1) + ' ' + x2 + ' 100" fill="none" stroke="#C05621" stroke-width="3" stroke-linecap="round"/>'
          + '<path d="M ' + x2 + ' 100 l 3 -9 m -3 9 l 10 -2" stroke="#C05621" stroke-width="2.5" fill="none" stroke-linecap="round"/>'
          + '<text x="' + mid.toFixed(1) + '" y="' + (100 - arcH / 2 - 10).toFixed(1) + '" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15" font-weight="700" fill="#C05621">−' + H.fmt(nc) + '/' + H.fmt(l) + '</text>';
        visual = '<div class="mc-tl"><p class="mc-tl-h">On the Number Line</p>'
          + '<svg viewBox="0 0 720 152" role="img" aria-label="Number line showing the hop back">' + svg + '</svg></div>';
      }
      return { answer: ans, steps: steps, visual: visual };
    }), preview: (function (v, H) {
      function one(w, n, d) {
        var ws = (w === '?' || Number(w) === 0) ? '' : w + ' ';
        return ws + H.frTok(n, d);
      }
      return one(v.w1, v.a, v.b) + '  −  ' + one(v.w2, v.c, v.d);
    }), widget: (function (v, H) {
      var w1 = Number(v.w1), a = Number(v.a), b = Number(v.b), w2 = Number(v.w2), c = Number(v.c), d = Number(v.d);
      var have = isFinite(w1) && isFinite(a) && isFinite(b) && isFinite(w2) && isFinite(c) && isFinite(d) && b > 0 && d > 0;
      if (!have) return '';
      var A = H.toImproper(w1, a, b), C = H.toImproper(w2, c, d);
      var L = b / H.gcd(b, d) * d;
      var n1 = A * (L / b), n2 = C * (L / d);
      var diff = n1 - n2;
      var mk = H.mkHtml;
      function fr(n, dd) { return mk(H.fracStr(n, dd)); }
      var gS = H.gcd(diff, L);
      var fin = H.mixedStr(diff / gS, L / gS);
      var seq = fr(n1, L) + ' − ' + fr(n2, L) + ' = ';
      seq += fin === H.fracStr(diff, L) ? '<b>' + fr(diff, L) + '</b>' : fr(diff, L) + ' = <b>' + mk(fin) + '</b>';
      var pre = [];
      if (L !== b) pre.push(fr(A, b) + ' = ' + fr(n1, L));
      if (L !== d) pre.push(fr(C, d) + ' = ' + fr(n2, L));
      var barLine = '<p class="mc-rule-line"><span class="mc-rule-f">' + (pre.length ? pre.join(' and ') + ', so ' : '') + seq + '</span>' +
        '<span class="mc-rule-why">Match the bottoms, then take the tops away.</span></p>';
      var drawable = w1 === 0 && w2 === 0 && a >= 0 && c >= 0 && a <= b && c <= d && b <= 12 && d <= 12 && L <= 24 &&
        Number.isInteger(a) && Number.isInteger(c) && Number.isInteger(b) && Number.isInteger(d) && diff >= 0 && n1 > 0;
      if (!drawable) return barLine;
      var recut = b !== d;
      var y = 0, rows = '';
      function row(label, cells1, f1a, f1b, lbl1, cells2, f2a, f2b, lbl2) {
        var out = '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">' + label + '</text>';
        out += H.fbBar(60, y + 20, 190, cells1, f1a, f1b) + H.fbFrac(280, y + 36, lbl1[0], lbl1[1]);
        if (cells2) {
          out += '<text class="mc-fb-op" x="316" y="' + (y + 45) + '">−</text>';
          out += H.fbBar(340, y + 20, 190, cells2, f2a, f2b) + H.fbFrac(560, y + 36, lbl2[0], lbl2[1]);
        }
        y += 80;
        return out;
      }
      rows += row('Your fractions', b, a, 0, [a, b], d, 0, c, [c, d]);
      if (recut) rows += row('Cut both into ' + H.fmt(L) + 'ths, the common denominator', L, n1, 0, [n1, L], L, 0, n2, [n2, L]);
      /* take-away row: the first fraction's pieces, with the last n2 of them
         crossed off, leaving the answer */
      var out3 = '<text class="mc-fb-sub" x="60" y="' + (y + 12) + '">Cross off ' + H.fmt(n2) + ' ' + H.plural(n2, 'piece', 'pieces') + '</text>';
      out3 += H.fbBar(60, y + 20, 190, L, n1, 0);
      var cw = 190 / L, i;
      for (i = diff; i < n1; i++) {
        var x1 = 60 + i * cw + 3, x2 = 60 + (i + 1) * cw - 3;
        out3 += '<line class="mc-fb-x" x1="' + x1.toFixed(1) + '" y1="' + (y + 24) + '" x2="' + x2.toFixed(1) + '" y2="' + (y + 50) + '"></line>' +
          '<line class="mc-fb-x" x1="' + x1.toFixed(1) + '" y1="' + (y + 50) + '" x2="' + x2.toFixed(1) + '" y2="' + (y + 24) + '"></line>';
      }
      out3 += H.fbFrac(280, y + 36, diff, L);
      y += 80;
      rows += out3;
      return '<p class="mc-tri-hint">Watch the bars: both fractions get cut into the same size pieces, then the second one’s pieces are crossed off.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 ' + (y - 14) + '" style="max-width:640px" role="group" aria-label="Bar model of the fraction subtraction">' + rows + '</svg>' +
        barLine;
    }) };
MC_CONFIG["multiply-fractions-calculator"] = { name: "Multiplying Fractions Calculator", fields: [{"id": "w1", "group": "A", "groupLabel": "First fraction", "slot": "whole", "label": "First whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "a", "group": "A", "slot": "num", "label": "First numerator (top)", "type": "number", "def": "2", "int": true}, {"id": "b", "group": "A", "slot": "den", "label": "First denominator (bottom)", "type": "number", "def": "3", "gt": 0, "int": true}, {"id": "sym", "slot": "op", "type": "static", "text": "\u00d7", "label": "Operation"}, {"id": "w2", "group": "B", "groupLabel": "Second fraction", "slot": "whole", "label": "Second whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "c", "group": "B", "slot": "num", "label": "Second numerator (top)", "type": "number", "def": "3", "int": true}, {"id": "d", "group": "B", "slot": "den", "label": "Second denominator (bottom)", "type": "number", "def": "4", "gt": 0, "int": true}], example: {"w1": 0, "a": 2, "b": 3, "w2": 0, "c": 3, "d": 4}, run: (function (v, H) {
      var steps = [];
      var b = Math.abs(v.b), d = Math.abs(v.d);
      var a = H.toImproper(v.w1, v.a, b);
      var c = H.toImproper(v.w2, v.c, d);
      if (v.w1 !== 0) steps.push('Turn the first mixed number into an improper fraction: ' + H.fmt(Math.abs(v.w1)) + ' × ' + H.fmt(b) + ' + ' + H.fmt(Math.abs(v.a)) + ' = ' + H.fmt(Math.abs(a)) + ', so it is ' + H.fracStr(a, b));
      if (v.w2 !== 0) steps.push('Same for the second: ' + H.fmt(Math.abs(v.w2)) + ' × ' + H.fmt(d) + ' + ' + H.fmt(Math.abs(v.c)) + ' = ' + H.fmt(Math.abs(c)) + ', so it is ' + H.fracStr(c, d));
      var n = a * c, dd = b * d;
      steps.push('No common denominator needed. Multiply the tops: ' + H.fmt(a) + ' × ' + H.fmt(c) + ' = ' + H.fmt(n));
      steps.push('Multiply the bottoms: ' + H.fmt(b) + ' × ' + H.fmt(d) + ' = ' + H.fmt(dd) + ', giving ' + H.fracStr(n, dd));
      if (dd < 0) { n = -n; dd = -dd; }
      var g = H.gcd(n, dd) || 1;
      var sn = n / g, sd = dd / g;
      if (g > 1) steps.push('Simplify: the highest common factor of ' + H.fmt(Math.abs(n)) + ' and ' + H.fmt(dd) + ' is ' + H.fmt(g) + ', so divide top and bottom by it to get ' + H.fracStr(sn, sd));
      var ans = H.mixedStr(sn, sd);
      if (Math.abs(sn) > sd && sd !== 1) steps.push(H.fracStr(sn, sd) + ' is top-heavy: ' + H.fmt(sd) + ' goes into ' + H.fmt(Math.abs(sn)) + ' ' + H.fmt(Math.floor(Math.abs(sn) / sd)) + ' times with ' + H.fmt(Math.abs(sn) % sd) + ' left over, so it is ' + ans);
      else if (g === 1) steps.push(ans + ' is already in its simplest form');
      return { answer: ans, steps: steps };
    }), preview: (function (v, H) {
      function one(w, n, d) {
        var ws = (w === '?' || Number(w) === 0) ? '' : w + ' ';
        return ws + H.frTok(n, d);
      }
      return one(v.w1, v.a, v.b) + '  ×  ' + one(v.w2, v.c, v.d);
    }), widget: (function (v, H) {
      var w1 = Number(v.w1), a = Number(v.a), b = Number(v.b), w2 = Number(v.w2), c = Number(v.c), d = Number(v.d);
      var have = isFinite(w1) && isFinite(a) && isFinite(b) && isFinite(w2) && isFinite(c) && isFinite(d) && b > 0 && d > 0;
      if (!have) return '';
      var A = H.toImproper(w1, a, b), C = H.toImproper(w2, c, d);
      var N = A * C, D = b * d;
      var mk = H.mkHtml;
      var gS = H.gcd(N, D);
      var fin = H.mixedStr(N / gS, D / gS);
      var prod = mk(H.fracStr(N, D));
      var seq = fin === H.fracStr(N, D) ? '<b>' + prod + '</b>' : prod + ' = <b>' + mk(fin) + '</b>';
      var barLine = '<p class="mc-rule-line"><span class="mc-rule-f">' + H.fmt(A) + ' × ' + H.fmt(C) + ' = ' + H.fmt(N) + ' on top, ' + H.fmt(b) + ' × ' + H.fmt(d) + ' = ' + H.fmt(D) + ' on the bottom: ' + seq + '</span>' +
        '<span class="mc-rule-why">Tops multiply, bottoms multiply, no common denominator needed.</span></p>';
      var drawable = w1 === 0 && w2 === 0 && a > 0 && c > 0 && a <= b && c <= d && b <= 8 && d <= 8 &&
        Number.isInteger(a) && Number.isInteger(c) && Number.isInteger(b) && Number.isInteger(d);
      if (!drawable) return barLine;
      var x0 = 160, y0 = 22, W = 280, Hh = 168;
      var cw = W / b, rh = Hh / d;
      var cells = '', i, j, cls;
      for (j = 0; j < d; j++) {
        for (i = 0; i < b; i++) {
          cls = i < a && j < c ? ' is-cb' : i < a ? ' is-c1' : j < c ? ' is-c2' : '';
          cells += '<rect class="mc-fb-cell' + cls + '" x="' + (x0 + i * cw).toFixed(1) + '" y="' + (y0 + j * rh).toFixed(1) + '" width="' + cw.toFixed(1) + '" height="' + rh.toFixed(1) + '"></rect>';
        }
      }
      return '<p class="mc-tri-hint">Multiplying fractions is a fraction OF a fraction: one shades the columns, the other shades the rows, and the answer is the dark overlap.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 244" style="max-width:640px" role="group" aria-label="Overlap grid for the fraction multiplication">' +
        cells +
        H.fbFrac(x0 + a * cw / 2, y0 + Hh + 26, a, b) +
        H.fbFrac(x0 + W + 36, y0 + c * rh / 2, c, d) +
        '<text class="mc-fb-sub" x="' + (x0 + W + 62) + '" y="' + (y0 + c * rh / 2 + 5) + '">of the rows</text>' +
        '<text class="mc-fb-sub" x="' + (x0 + a * cw / 2 + 26) + '" y="' + (y0 + Hh + 32) + '">of the columns</text>' +
        '<text class="mc-fb-sub" x="' + x0 + '" y="14">The dark overlap: ' + H.fmt(N) + ' of the ' + H.fmt(D) + ' cells</text>' +
        '</svg>' + barLine;
    }) };
MC_CONFIG["divide-fractions-calculator"] = { name: "Dividing Fractions Calculator", fields: [{"id": "w1", "group": "A", "groupLabel": "First fraction", "slot": "whole", "label": "First whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "a", "group": "A", "slot": "num", "label": "First numerator (top)", "type": "number", "def": "1", "int": true}, {"id": "b", "group": "A", "slot": "den", "label": "First denominator (bottom)", "type": "number", "def": "2", "gt": 0, "int": true}, {"id": "sym", "slot": "op", "type": "static", "text": "\u00f7", "label": "Operation"}, {"id": "w2", "group": "B", "groupLabel": "Second fraction", "slot": "whole", "label": "Second whole number (0 if none)", "type": "number", "def": "0", "int": true}, {"id": "c", "group": "B", "slot": "num", "label": "Second numerator (top)", "type": "number", "def": "1", "int": true}, {"id": "d", "group": "B", "slot": "den", "label": "Second denominator (bottom)", "type": "number", "def": "4", "gt": 0, "int": true}], example: {"w1": 0, "a": 1, "b": 2, "w2": 0, "c": 1, "d": 4}, run: (function (v, H) {
      var steps = [];
      var b = Math.abs(v.b), d = Math.abs(v.d);
      var a = H.toImproper(v.w1, v.a, b);
      var c = H.toImproper(v.w2, v.c, d);
      if (v.w1 !== 0) steps.push('Turn the first mixed number into an improper fraction: ' + H.fmt(Math.abs(v.w1)) + ' × ' + H.fmt(b) + ' + ' + H.fmt(Math.abs(v.a)) + ' = ' + H.fmt(Math.abs(a)) + ', so it is ' + H.fracStr(a, b));
      if (v.w2 !== 0) steps.push('Same for the second: ' + H.fmt(Math.abs(v.w2)) + ' × ' + H.fmt(d) + ' + ' + H.fmt(Math.abs(v.c)) + ' = ' + H.fmt(Math.abs(c)) + ', so it is ' + H.fracStr(c, d));
      if (c === 0) throw new Error('You cannot divide by zero, so the second fraction must not be 0.');
      var n = a * d, dd = b * c;
      steps.push('Keep the first, flip the second, change ÷ into ×: ' + H.fracStr(a, b) + ' × ' + H.fracStr(d, c));
      steps.push('Now multiply across: ' + H.fmt(a) + ' × ' + H.fmt(d) + ' = ' + H.fmt(n) + ' and ' + H.fmt(b) + ' × ' + H.fmt(c) + ' = ' + H.fmt(dd) + ', giving ' + H.fracStr(n, dd));
      if (dd < 0) { n = -n; dd = -dd; }
      var g = H.gcd(n, dd) || 1;
      var sn = n / g, sd = dd / g;
      if (g > 1) steps.push('Simplify: the highest common factor of ' + H.fmt(Math.abs(n)) + ' and ' + H.fmt(dd) + ' is ' + H.fmt(g) + ', so divide top and bottom by it to get ' + H.fracStr(sn, sd));
      var ans = H.mixedStr(sn, sd);
      if (Math.abs(sn) > sd && sd !== 1) steps.push(H.fracStr(sn, sd) + ' is top-heavy: ' + H.fmt(sd) + ' goes into ' + H.fmt(Math.abs(sn)) + ' ' + H.fmt(Math.floor(Math.abs(sn) / sd)) + ' times with ' + H.fmt(Math.abs(sn) % sd) + ' left over, so it is ' + ans);
      else if (g === 1) steps.push(ans + ' is already in its simplest form');
      return { answer: ans, steps: steps };
    }), preview: (function (v, H) {
      function one(w, n, d) {
        var ws = (w === '?' || Number(w) === 0) ? '' : w + ' ';
        return ws + H.frTok(n, d);
      }
      return one(v.w1, v.a, v.b) + '  ÷  ' + one(v.w2, v.c, v.d);
    }), widget: (function (v, H) {
      var w1 = Number(v.w1), a = Number(v.a), b = Number(v.b), w2 = Number(v.w2), c = Number(v.c), d = Number(v.d);
      var have = isFinite(w1) && isFinite(a) && isFinite(b) && isFinite(w2) && isFinite(c) && isFinite(d) && b > 0 && d > 0;
      if (!have) return '';
      var A = H.toImproper(w1, a, b), C = H.toImproper(w2, c, d);
      if (C === 0) return '';
      var N = A * d, D = b * C;
      var mk = H.mkHtml;
      var gS = H.gcd(N, D);
      var fin = H.mixedStr(N / gS, D / gS);
      var prod = mk(H.fracStr(N, D));
      var seq = fin === H.fracStr(N, D) ? '<b>' + prod + '</b>' : prod + ' = <b>' + mk(fin) + '</b>';
      var barLine = '<p class="mc-rule-line"><span class="mc-rule-f">' + mk(H.fracStr(A, b)) + ' × ' + mk(H.fracStr(d, C)) + ' = ' + seq + '</span>' +
        '<span class="mc-rule-why">Keep, flip, change: dividing becomes multiplying.</span></p>';
      var aA = Math.abs(A), aC = Math.abs(C);
      function card(x, cls, tag2, midSvg, sub) {
        return '<rect class="mc-kfc-card' + cls + '" x="' + x + '" y="6" width="150" height="112" rx="14"></rect>' +
          '<text class="mc-kfc-tag" x="' + (x + 75) + '" y="32">' + tag2 + '</text>' + midSvg +
          '<text class="mc-kfc-sub" x="' + (x + 75) + '" y="104">' + sub + '</text>';
      }
      var neg1 = A < 0 ? '<text class="mc-kfc-big" x="' + (40 + 52) + '" y="72">−</text>' : '';
      var cards = card(40, '', 'KEEP', neg1 + H.fbFrac(40 + 75, 66, H.fmt(aA), H.fmt(b)), 'the first fraction stays') +
        '<text class="mc-kfc-big" x="215" y="70">→</text>' +
        card(235, ' is-2', 'FLIP', H.fbFrac(235 + 47, 66, H.fmt(aC), H.fmt(d)) +
          '<text class="mc-kfc-big" x="' + (235 + 75) + '" y="72">→</text>' +
          H.fbFrac(235 + 104, 66, H.fmt(d), H.fmt(aC)), 'turn it upside down') +
        '<text class="mc-kfc-big" x="410" y="70">→</text>' +
        card(430, ' is-3', 'CHANGE', '<text class="mc-kfc-big" x="' + (430 + 75) + '" y="72">÷  →  ×</text>', 'divide becomes times');
      var y = 134;
      var rows = '';
      /* the fit bar joins in when everything is simple and the pieces fit
         a whole number of times */
      var L = b / H.gcd(b, d) * d;
      var n1 = a * (L / b), n2 = c * (L / d);
      var clean = w1 === 0 && w2 === 0 && a > 0 && c > 0 && a <= b && c <= d && b <= 12 && d <= 12 && L <= 24 &&
        Number.isInteger(a) && Number.isInteger(c) && Number.isInteger(b) && Number.isInteger(d) &&
        n2 > 0 && n1 % n2 === 0;
      if (clean) {
        var k = n1 / n2, i;
        rows += '<text class="mc-fb-sub" x="60" y="' + (y + 14) + '">What it means: cut into ' + H.fmt(L) + 'ths, then count how many groups of ' + H.fmt(n2) + ' fit</text>';
        rows += H.fbBar(60, y + 22, 300, L, n1, 0) + H.fbFrac(388, y + 38, H.fmt(n1), H.fmt(L));
        var cw = 300 / L;
        for (i = 0; i < k; i++) {
          var xs = 60 + i * n2 * cw + 3, xe = 60 + (i + 1) * n2 * cw - 3;
          rows += '<path class="mc-fb-brk" d="M' + xs.toFixed(1) + ' ' + (y + 62) + 'v8h' + (xe - xs).toFixed(1) + 'v-8"></path>' +
            '<text class="mc-fb-cnt" x="' + ((xs + xe) / 2).toFixed(1) + '" y="' + (y + 90) + '">' + H.fmt(i + 1) + '</text>';
        }
        rows += '<text class="mc-fb-sub" x="60" y="' + (y + 114) + '">It fits exactly ' + H.fmt(k) + ' ' + H.plural(k, 'time', 'times') + ', so the answer is ' + H.fmt(k) + '</text>';
        y += 122;
      }
      return '<p class="mc-tri-hint">Keep, flip, change: three moves and the division becomes a multiplication.' + (clean ? ' The bar below shows what it means: counting how many fit.' : '') + '</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 ' + y + '" style="max-width:640px" role="group" aria-label="Keep flip change, and how many of the second fraction fit in the first">' +
        cards + rows + '</svg>' + barLine;
    }) };
MC_CONFIG["negative-numbers-calculator"] = { name: "Negative Numbers Calculator", fields: [{"id": "a", "label": "First number", "type": "number", "def": "-6"}, {"id": "op", "label": "Operation", "type": "select", "def": "sub", "options": [["add", "Add (+)"], ["sub", "Subtract (\u2212)"], ["mul", "Multiply (\u00d7)"], ["div", "Divide (\u00f7)"]]}, {"id": "b", "label": "Second number", "type": "number", "def": "-4"}], example: {"a": -6, "op": "sub", "b": -4}, run: (function (v, H) {
      function br(n) { return n < 0 ? '(−' + H.fmt(Math.abs(n)) + ')' : H.fmt(n); }
      function neat(n) { return n < 0 ? '−' + H.fmt(Math.abs(n)) : H.fmt(n); }
      /* the move drawn as one hop on a number line, zero marked when nearby */
      function numberLine(a, ans) {
        var delta = ans - a;
        if (delta === 0) return '';
        var lo = Math.min(a, ans), hi = Math.max(a, ans), span = hi - lo;
        var showZero = 0 >= lo - span && 0 <= hi + span;
        if (showZero) { lo = Math.min(lo, 0); hi = Math.max(hi, 0); span = hi - lo; }
        var pad = span * 0.12;
        lo -= pad; hi += pad; span = hi - lo;
        function X(t) { return (40 + (t - lo) / span * 640).toFixed(1); }
        var svg = '<line x1="24" y1="112" x2="696" y2="112" stroke="#B8CCD8" stroke-width="2.5" stroke-linecap="round"/>'
          + '<path d="M 696 112 l -9 -5 m 9 5 l -9 5" stroke="#B8CCD8" stroke-width="2.5" fill="none" stroke-linecap="round"/>'
          + '<path d="M 24 112 l 9 -5 m -9 5 l 9 5" stroke="#B8CCD8" stroke-width="2.5" fill="none" stroke-linecap="round"/>';
        var ints = Number.isInteger(a) && Number.isInteger(ans) && span <= 26;
        if (ints) {
          for (var t = Math.ceil(lo); t <= Math.floor(hi); t++) {
            svg += '<line x1="' + X(t) + '" y1="107" x2="' + X(t) + '" y2="117" stroke="#D3E0E8" stroke-width="1.6"/>';
          }
        }
        function mark(t, ink, lbl) {
          return '<line x1="' + X(t) + '" y1="102" x2="' + X(t) + '" y2="122" stroke="' + ink + '" stroke-width="2.5" stroke-linecap="round"/>'
            + '<text x="' + X(t) + '" y="143" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15.5" font-weight="800" fill="' + ink + '">' + lbl + '</text>';
        }
        if (showZero && a !== 0 && ans !== 0) svg += mark(0, '#93A8B8', '0');
        svg += mark(a, '#2F6886', neat(a)) + mark(ans, '#B4531F', neat(ans));
        var ink = delta > 0 ? '#2F855A' : '#C05621';
        var x1 = Number(X(a)), x2 = Number(X(ans)), mid = (x1 + x2) / 2;
        var arcH = Math.min(64, 26 + Math.abs(x2 - x1) * 0.12);
        svg += '<path d="M ' + x1 + ' 100 Q ' + mid.toFixed(1) + ' ' + (100 - arcH).toFixed(1) + ' ' + x2 + ' 100" fill="none" stroke="' + ink + '" stroke-width="3" stroke-linecap="round"/>'
          + '<path d="M ' + x2 + ' 100 l ' + (delta > 0 ? '-3 -9 m 3 9 l -10 -2' : '3 -9 m -3 9 l 10 -2') + '" stroke="' + ink + '" stroke-width="2.5" fill="none" stroke-linecap="round"/>'
          + '<text x="' + mid.toFixed(1) + '" y="' + (100 - arcH / 2 - 10).toFixed(1) + '" text-anchor="middle" font-family="Lexend, Inter, sans-serif" font-size="15" font-weight="700" fill="' + ink + '">'
          + (delta > 0 ? '+' + H.fmt(delta) : '−' + H.fmt(Math.abs(delta))) + '</text>';
        return '<div class="mc-tl"><p class="mc-tl-h">On the Number Line</p>'
          + '<svg viewBox="0 0 720 152" role="img" aria-label="Number line showing the move">' + svg + '</svg></div>';
      }
      var steps = [], ans;
      if (v.op === 'add') {
        ans = v.a + v.b;
        if (v.b < 0) steps.push('Adding a negative moves you LEFT on the number line, so ' + br(v.a) + ' + ' + br(v.b) + ' is the same as ' + neat(v.a) + ' − ' + H.fmt(Math.abs(v.b)));
        else steps.push('Adding a positive moves you RIGHT on the number line, starting from ' + neat(v.a));
        steps.push('Work it out: ' + neat(v.a) + (v.b < 0 ? ' − ' + H.fmt(Math.abs(v.b)) : ' + ' + H.fmt(v.b)) + ' = ' + neat(ans));
      } else if (v.op === 'sub') {
        ans = v.a - v.b;
        if (v.b < 0) steps.push('Subtracting a negative is the two-minus rule: ' + br(v.a) + ' − ' + br(v.b) + ' becomes ' + neat(v.a) + ' + ' + H.fmt(Math.abs(v.b)) + ', because taking away a debt makes you better off');
        else steps.push('Subtracting a positive moves you LEFT on the number line, starting from ' + neat(v.a));
        steps.push('Work it out: ' + neat(v.a) + (v.b < 0 ? ' + ' + H.fmt(Math.abs(v.b)) : ' − ' + H.fmt(v.b)) + ' = ' + neat(ans));
      } else if (v.op === 'mul') {
        ans = v.a * v.b;
        var same = (v.a < 0) === (v.b < 0);
        steps.push('Ignore the signs first and multiply the sizes: ' + H.fmt(Math.abs(v.a)) + ' × ' + H.fmt(Math.abs(v.b)) + ' = ' + H.fmt(Math.abs(v.a) * Math.abs(v.b)));
        steps.push(same
          ? 'The signs MATCH, so the answer is positive: ' + neat(ans)
          : 'The signs are DIFFERENT, so the answer is negative: ' + neat(ans));
      } else {
        if (v.b === 0) throw new Error('You cannot divide by zero. Try a second number that is not 0.');
        ans = v.a / v.b;
        var same2 = (v.a < 0) === (v.b < 0);
        steps.push('Ignore the signs first and divide the sizes: ' + H.fmt(Math.abs(v.a)) + ' ÷ ' + H.fmt(Math.abs(v.b)) + ' = ' + H.fmt(Math.abs(v.a) / Math.abs(v.b)));
        steps.push(same2
          ? 'The signs MATCH, so the answer is positive: ' + neat(ans)
          : 'The signs are DIFFERENT, so the answer is negative: ' + neat(ans));
      }
      return {
        answer: neat(ans), steps: steps,
        visual: (v.op === 'add' || v.op === 'sub') ? numberLine(v.a, ans) : '',
        note: v.op === 'mul' || v.op === 'div'
          ? 'Sign rule for × and ÷: same signs give a positive, different signs give a negative.'
          : 'Picture the number line: negatives sit left of zero, and every calculation is a move along it.'
      };
    }), preview: (function (v, H) {
      var sym = { add: '+', sub: '−', mul: '×', div: '÷' }[v.op];
      function br(n) { return String(n).charAt(0) === '-' ? '(' + String(n).replace('-', '−') + ')' : String(n); }
      return br(v.a) + '  ' + sym + '  ' + br(v.b);
    }) };
MC_CONFIG["simplify-fractions-calculator"] = { name: "Simplify Fractions Calculator", fields: [{"id": "n", "group": "F", "groupLabel": "The fraction", "slot": "num", "label": "Numerator (top)", "type": "number", "def": "18", "int": true}, {"id": "d", "group": "F", "slot": "den", "label": "Denominator (bottom)", "type": "number", "def": "24", "gt": 0, "int": true}], example: {"n": 18, "d": 24}, run: (function (v, H) {
      if (v.n === 0) {
        return { answer: '0', steps: ['A top of 0 means no parts at all', H.frTok('0', H.fmt(v.d)) + ' is simply 0'] };
      }
      var g = H.gcd(v.n, v.d);
      var sn = v.n / g, sd = v.d / g;
      var steps = [];
      if (g === 1) {
        steps.push('Look for a number that divides both ' + H.fmt(Math.abs(v.n)) + ' and ' + H.fmt(v.d) + ': the highest common factor is 1');
        steps.push('Nothing bigger than 1 goes into both, so ' + H.fracStr(v.n, v.d) + ' is already in its simplest form');
        return { answer: H.mixedStr(sn, sd), steps: steps };
      }
      steps.push('Find the highest common factor of ' + H.fmt(Math.abs(v.n)) + ' and ' + H.fmt(v.d) + ': it is ' + H.fmt(g));
      steps.push('Divide the top by it: ' + H.fmt(Math.abs(v.n)) + ' ÷ ' + H.fmt(g) + ' = ' + H.fmt(Math.abs(sn)));
      steps.push('Divide the bottom by the SAME number: ' + H.fmt(v.d) + ' ÷ ' + H.fmt(g) + ' = ' + H.fmt(sd) + ', giving ' + H.fracStr(sn, sd));
      var ans = H.mixedStr(sn, sd);
      if (ans !== H.fracStr(sn, sd)) steps.push(H.fracStr(sn, sd) + ' is top-heavy, so write it as the mixed number ' + ans);
      return {
        answer: ans, steps: steps,
        note: 'A fraction is in its simplest form when the only number dividing both parts is 1.'
      };
    }), preview: (function (v, H) { return 'Simplify ' + H.frTok(v.n, v.d); }), widget: (function (v, H) {
      var n = Number(v.n), d = Number(v.d);
      if (!isFinite(n) || !isFinite(d) || d <= 0) return '';
      var g = H.gcd(n, d);
      var sn = n / g, sd = d / g;
      var mk = H.mkHtml;
      var barLine = g > 1
        ? '<p class="mc-rule-line"><span class="mc-rule-f">Divide top and bottom by ' + H.fmt(g) + ': ' + mk(H.fracStr(n, d)) + ' = <b>' + mk(H.mixedStr(sn, sd)) + '</b></span><span class="mc-rule-why">The highest common factor of ' + H.fmt(Math.abs(n)) + ' and ' + H.fmt(d) + ' is ' + H.fmt(g) + '.</span></p>'
        : '<p class="mc-rule-line"><span class="mc-rule-f">' + mk(H.fracStr(n, d)) + ' is already in its simplest form</span><span class="mc-rule-why">Nothing bigger than 1 divides both the top and the bottom.</span></p>';
      var drawable = Number.isInteger(n) && Number.isInteger(d) && n > 0 && n < d && d <= 24 && g > 1;
      if (!drawable) return barLine;
      var rows = '<text class="mc-fb-sub" x="60" y="12">Your fraction</text>' +
        H.fbBar(60, 20, 300, d, n, 0) + H.fbFrac(388, 36, H.fmt(n), H.fmt(d)) +
        '<text class="mc-fb-sub" x="60" y="92">Group into pieces ' + H.fmt(g) + ' times bigger: the shaded amount does not change</text>' +
        H.fbBar(60, 100, 300, sd, sn, 0) + H.fbFrac(388, 116, H.fmt(sn), H.fmt(sd));
      return '<p class="mc-tri-hint">Simplifying never changes the amount, only the size of the pieces.</p>' +
        '<svg class="mc-tri" viewBox="0 0 600 146" style="max-width:640px" role="group" aria-label="Bar model of the simplification">' + rows + '</svg>' + barLine;
    }) };